// Auto-generated by scripts/prefetch-marketing-pages.mjs — DO NOT EDIT
// Generated at: 2026-08-27T07:46:27.283Z
export const MARKETING_PAGE_DATA: Record<string, any> = {
  "home": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "gsi1sk": "PAGE#1773919984943",
      "text_color": "#000000",
      "post_text_color": "#ffffff",
      "page_id": 1773919984943,
      "secondary_background_color": "#000000",
      "updated_at": 1775033107580,
      "gsi1pk": "home",
      "meta_title": "TopFan - The Best Platform for Creators",
      "type": "HOME_PAGE",
      "pk": "MARKETINGPAGE",
      "seoKeywords": "creator monetization platform, white labeled, apps, premium subscriptions, merchandise, newsletters, livestreams, personal experiences, paid direct messages, tips",
      "button_text_color": "#ffffff",
      "url": "home",
      "background_color": "#fffcf2",
      "created_at": 1773919984943,
      "status": "PUBLISHED",
      "title": "Home Page",
      "sk": "PAGE#1773919984943",
      "background_text_color": "#0f0c0c",
      "meta_description": "TopFan provides creators with their own personal branded website and app, with all their monetization offerings in a single place, so they can finally own and leverage comprehensive data about their fans. Creators can sell premium subscriptions, merchandise, newsletters, livestreams, experiences, paid direct messages, tips and build a more personal relationship with their best fans.",
      "sections": [
        {
          "background_color": "#fffcf2",
          "background_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775198158081_hero_page_background.png",
          "background_text_color": "#0f0c0c",
          "button_text_color": "#ffffff",
          "created_at": 1774425123523,
          "cta_link": "/?get_started=true",
          "cta_link_2": "",
          "cta_text": "Get Started",
          "cta_text_2": "",
          "heading_font_size": "large",
          "heading_position": "left",
          "layout_id": "hero-side-image-layout",
          "name": "P",
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#ffffff",
          "poster_url": "https://cdn-www.topfans.com/TopFans/1775196031776.jpg",
          "secondary_background_color": "#000000",
          "section_heading": "{Your Platform.} Not Theirs.",
          "section_id": 1774425123523,
          "sequence_number": 1,
          "side_image_desktop": null,
          "side_image_mobile": null,
          "subheading": "",
          "theme_color": "#000000",
          "title": "P",
          "updated_at": 1778580741950,
          "video_url": "https://cdn-www6.topfan.dev/Posts/PostVideo/post_1778234003491_lzsbks_59l6g5",
          "sk": "SECTION#1774425123523"
        },
        {
          "background_color": "#000000",
          "background_text_color": "#f0f0f0",
          "brand_images": [
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254918_brand_logo_fox.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_maroon_5.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_mgm.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_nflpa.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_pitbull.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_the_luminors.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_wb.png",
            "https://cdn-www6.topfan.dev/TopFans/Home1775550254920_brand_logo_tool.png"
          ],
          "button_text_color": "#ffffff",
          "created_at": 1774264620957,
          "heading_font_size": "medium",
          "layout_id": "trusted-brands-layout",
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "[Trusted by] Top Sports & Entertainment Brands",
          "section_id": 1774264620957,
          "sequence_number": 2,
          "theme_color": "#000000",
          "title": "trusted",
          "updated_at": 1777283607737,
          "sk": "SECTION#1774264620957"
        },
        {
          "background_color": "#fffcf2",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1775475616095_section_3_background.png",
          "background_text_color": "#0f0c0c",
          "bullet_image_1": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775123116832_balance_by_seana.png",
          "bullet_image_2": null,
          "bullet_image_3": null,
          "bullet_point_1": "",
          "bullet_point_2": "",
          "bullet_point_3": "",
          "button_text_color": "#ffffff",
          "created_at": 1774014882367,
          "cta_link": "creators",
          "cta_link_2": "request-demo",
          "cta_text": "LEARN MORE",
          "cta_text_2": "REQUEST DEMO",
          "heading_position": "right",
          "layout_id": "image-left-layout",
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "The Leader In {Direct-to-Fan}",
          "section_id": 1774014882367,
          "sequence_number": 4,
          "subheading": "Founded in 2013, TopFan pioneered how creators monetize and directly engage with their superfans. \\n\\nToday, TopFan is trusted by the most respected creators in music, sports, podcasting, digital video, film & television.\\n\\n  TopFan's technology allows any type of creator to unify their fan experience onto their own white-labeled website and mobile app platform, bringing all aspects of fan monetization and engagement into one-place.  Creators can now directly deliver their Content, Community and Commerce, and own the collected fan data. \\n\\nThis gives the creator unprecedented control to build a sustainable direct-to-fan business that is not beholden to someone else's rules or algorithms.",
          "theme_color": "#000000",
          "title": "2",
          "updated_at": 1775823642714,
          "sk": "SECTION#1774014882367"
        },
        {
          "background_color": "#fffcf2",
          "background_text_color": "#0f0c0c",
          "button_text_color": "#ffffff",
          "created_at": 1774868551159,
          "cta_link": "/?get_started=true",
          "cta_text": "Get Started",
          "layout_id": "listing-feature-carousel-layout",
          "listing_fc_1_description": "Reduce social platform dependency with fully white-labeled websites and iOS/Android mobile apps for your fan community.",
          "listing_fc_1_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010519_container_1.png",
          "listing_fc_1_redirection_link": "",
          "listing_fc_1_title": "Your Own Direct-to-Fan Platform",
          "listing_fc_2_description": "All your content is in one place including videos, podcasts, music, courses, articles via subscription or single purchase.",
          "listing_fc_2_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_2.png",
          "listing_fc_2_redirection_link": "",
          "listing_fc_2_title": "Sell Premium Content",
          "listing_fc_3_description": "Integrated physical merchandise sales and personalized 1:1 fan experiences, including video calls and shoutouts.",
          "listing_fc_3_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_3.png",
          "listing_fc_3_redirection_link": "",
          "listing_fc_3_title": "Merchandise & Experiences",
          "listing_fc_4_description": "Interactive livestream technology with ability to sell your products and services directly during the video livestream.",
          "listing_fc_4_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container4.png",
          "listing_fc_4_redirection_link": "",
          "listing_fc_4_title": "Go Live With Your FansGo Live With Your Fans",
          "listing_fc_5_description": "Build a database of fans and proactively send them free or locked newsletter content by email.",
          "listing_fc_5_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_5.png",
          "listing_fc_5_title": "Powerful Email Newsletters",
          "listing_fc_6_description": "Own and manage detailed data profiles about your fans and send targeted SMS, Emails, App Notifications, and DMs.",
          "listing_fc_6_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_6.png",
          "listing_fc_6_title": "Fan Relationship Management",
          "listing_feature_carousel_cards": [
            {
              "title": "Your Own Direct-to-Fan Platform",
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010519_container_1.png",
              "description": "Reduce social platform dependency with fully white-labeled websites and iOS/Android mobile apps for your fan community."
            },
            {
              "title": "Sell Premium Content",
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_2.png",
              "description": "All your content is in one place including videos, podcasts, music, courses, articles via subscription or single purchase."
            },
            {
              "title": "Merchandise & Experiences",
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_3.png",
              "description": "Integrated physical merchandise sales and personalized 1:1 fan experiences, including video calls and shoutouts."
            },
            {
              "title": "Go Live With Your FansGo Live With Your Fans",
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container4.png",
              "description": "Interactive livestream technology with ability to sell your products and services directly during the video livestream."
            },
            {
              "title": "Powerful Email Newsletters",
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_5.png",
              "description": "Build a database of fans and proactively send them free or locked newsletter content by email."
            },
            {
              "title": "Fan Relationship Management",
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1775037010520_container_6.png",
              "description": "Own and manage detailed data profiles about your fans and send targeted SMS, Emails, App Notifications, and DMs."
            }
          ],
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#000000",
          "secondary_background_color": "#fffcf2",
          "section_heading": "World Class Creator {Monetization & Fan Engagement Features}",
          "section_id": 1774868551159,
          "sequence_number": 5,
          "theme_color": "#000000",
          "title": "9",
          "updated_at": 1775823642714,
          "sk": "SECTION#1774868551159"
        },
        {
          "background_color": "#000000",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1775482756409_sectionx_background.png",
          "background_text_color": "#ffffff",
          "button_text_color": "#ffffff",
          "created_at": 1774099654453,
          "heading_font_size": "medium",
          "is_visible": true,
          "layout_id": "vertical-card-carousel-layout",
          "name": "DIRECT-TO-FAN SOLUTIONS FOR EVERY CREATOR",
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "[Direct-To-Fan] Solutions For Every Creator",
          "section_id": 1774099654453,
          "sequence_number": 6,
          "theme_color": "#ffffff",
          "title": "Direct-To-Fan Solutions for Every Creator",
          "updated_at": 1780643203774,
          "vertical_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778057628978_fe_hero_mob_mu.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/music-artists",
              "heading": "Music Artists",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779878181805_h_health.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/health-wellness-fitness",
              "heading": "Health, Wellness & Fitness",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779878181806_h_athlete.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/athletes",
              "heading": "Athletes",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777975428571_f_pro_sl.png",
              "cta_text": "Learn More",
              "redirection_link": "/podcasters-journalists-authors",
              "heading": "Podcasters & Journalists",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778759612322_h_s.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/sports-teams-NIL",
              "heading": "Sports Teams & NIL",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779714704696_h_beau.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/beauty-fashion",
              "heading": "Beauty & Fashion",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778759612323_h_e.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/entertainers-performers",
              "heading": "Entertainers & Performers",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778845248123_tv_home_creator.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/film-tv-microdramas",
              "heading": "Film, TV & Microdramas",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779714704696_h_gamer.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/gamers-streamers",
              "heading": "Gamers & Streamers",
              "subheading": ""
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780404555031_h_f_w.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/food-nutrition",
              "heading": "Food & Nutrition",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779449688009_1936.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/politics-movements",
              "heading": "Politics & Movements",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1780300251416_h_m_o.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/membership-organizations",
              "heading": "Membership Organizations",
              "subheading": ""
            }
          ],
          "verticle_10_cta_text": "Learn More",
          "verticle_10_heading": "Food & Nutrition",
          "verticle_10_image": "https://cdn-www7.topfans.dev/TopFans/Home1780404555031_h_f_w.jpg",
          "verticle_10_redirection_link": "/food-nutrition",
          "verticle_10_subheading": "",
          "verticle_11_cta_text": "Learn More",
          "verticle_11_heading": "Politics & Movements",
          "verticle_11_image": "https://cdn-www.topfans.com/TopFans/Home1779449688009_1936.jpg",
          "verticle_11_redirection_link": "/politics-movements",
          "verticle_11_subheading": "",
          "verticle_12_cta_text": "Learn More",
          "verticle_12_heading": "Membership Organizations",
          "verticle_12_image": "https://cdn-www.topfans.com/TopFans/Home1780300251416_h_m_o.jpg",
          "verticle_12_redirection_link": "/membership-organizations",
          "verticle_12_subheading": "",
          "verticle_1_cta_text": "Learn More",
          "verticle_1_heading": "Music Artists",
          "verticle_1_image": "https://cdn-www.topfans.com/TopFans/Home1778057628978_fe_hero_mob_mu.jpg",
          "verticle_1_redirection_link": "/music-artists",
          "verticle_1_subheading": "",
          "verticle_2_cta_text": "Learn More",
          "verticle_2_heading": "Health, Wellness & Fitness",
          "verticle_2_image": "https://cdn-www.topfans.com/TopFans/Home1779878181805_h_health.jpg",
          "verticle_2_redirection_link": "/health-wellness-fitness",
          "verticle_2_subheading": "",
          "verticle_3_cta_text": "Learn More",
          "verticle_3_heading": "Athletes",
          "verticle_3_image": "https://cdn-www.topfans.com/TopFans/Home1779878181806_h_athlete.jpg",
          "verticle_3_redirection_link": "/athletes",
          "verticle_3_subheading": "",
          "verticle_4_cta_text": "Learn More",
          "verticle_4_heading": "Podcasters & Journalists",
          "verticle_4_image": "https://cdn-www.topfans.com/TopFans/Home1777975428571_f_pro_sl.png",
          "verticle_4_redirection_link": "/podcasters-journalists-authors",
          "verticle_4_subheading": "",
          "verticle_5_cta_text": "Learn More",
          "verticle_5_heading": "Sports Teams & NIL",
          "verticle_5_image": "https://cdn-www.topfans.com/TopFans/Home1778759612322_h_s.jpg",
          "verticle_5_redirection_link": "/sports-teams-NIL",
          "verticle_5_subheading": "",
          "verticle_6_cta_text": "Learn More",
          "verticle_6_heading": "Beauty & Fashion",
          "verticle_6_image": "https://cdn-www.topfans.com/TopFans/Home1779714704696_h_beau.jpg",
          "verticle_6_redirection_link": "/beauty-fashion",
          "verticle_6_subheading": "",
          "verticle_7_cta_text": "Learn More",
          "verticle_7_heading": "Entertainers & Performers",
          "verticle_7_image": "https://cdn-www.topfans.com/TopFans/Home1778759612323_h_e.jpg",
          "verticle_7_redirection_link": "/entertainers-performers",
          "verticle_7_subheading": "",
          "verticle_8_cta_text": "Learn More",
          "verticle_8_heading": "Film, TV & Microdramas",
          "verticle_8_image": "https://cdn-www.topfans.com/TopFans/Home1778845248123_tv_home_creator.jpg",
          "verticle_8_redirection_link": "/film-tv-microdramas",
          "verticle_8_subheading": "",
          "verticle_9_cta_text": "Learn More",
          "verticle_9_heading": "Gamers & Streamers",
          "verticle_9_image": "https://cdn-www.topfans.com/TopFans/Home1779714704696_h_gamer.jpg",
          "verticle_9_redirection_link": "/gamers-streamers",
          "verticle_9_subheading": "",
          "sk": "SECTION#1774099654453"
        },
        {
          "background_color": "#000000",
          "background_text_color": "#0f0c0c",
          "button_text_color": "#000000",
          "created_at": 1774018223592,
          "cta_link": "https://www.topfan.com/pro/",
          "cta_text": "Try Now",
          "heading_font_size": "large",
          "heading_position": "right",
          "hero_image": "https://cdn-www6.topfan.dev/TopFans/Home1775635850860_tichkau.png",
          "include_highlighted_border": "true",
          "layout_id": "banner-cta-layout",
          "logo_image": "https://cdn-www6.topfan.dev/TopFans/Home1775635925588_chhota_tichkiu__1_.png",
          "mobile_image": "https://cdn-www6.topfan.dev/TopFans/Home1775551162194_topfan_pro_mobile.png",
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#480e0e",
          "section_heading": "Introducting TopFan [Pro]",
          "section_id": 1774018223592,
          "sequence_number": 7,
          "side_image": "https://cdn-www6.topfan.dev/TopFans/Home1775814445087_frame_2147226113.png",
          "subheading": "Need an enterprise level Direct-to-Fan solution with additional customization and dedicated account team? TopFan Pro is our premium fan engagement and monetization solution that is trusted by large movie studios, sports teams, music artists and membership associations.",
          "theme_color": "#ffffff",
          "title": "3",
          "updated_at": 1777282982638,
          "sk": "SECTION#1774018223592"
        },
        {
          "background_color": "#d0e9ee",
          "background_image": null,
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "created_at": 1774250114912,
          "heading_font_size": "medium",
          "layout_id": "testimonial-layout",
          "name": "5",
          "page_id": 1773919984943,
          "pk": "PAGE#1773919984943",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "Don't take our word for it. \\n{Over 10K+} people trust us.",
          "section_id": 1774250114912,
          "sequence_number": 8,
          "testimonial_1_background_image": null,
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_1_fan_count_text": "1.5M Fans",
          "testimonial_1_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_profile_1745871580146_jw_fitness_hs__25_update_square.jpg",
          "testimonial_1_name": "John Ward",
          "testimonial_1_redirection_link": "https://www.triplespur.com/triplespurband",
          "testimonial_1_stars": "5",
          "testimonial_1_user_name": "johnward",
          "testimonial_2_background_image": null,
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_2_fan_count_text": "1 Million Fans",
          "testimonial_2_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_julia.jpg",
          "testimonial_2_name": "Julia Julia",
          "testimonial_2_redirection_link": "https://www.triplespur.com/triplespurband",
          "testimonial_2_stars": "5",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_3_background_image": null,
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "testimonial_3_fan_count_text": "2M Followers",
          "testimonial_3_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_katrina.jpg",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_3_redirection_link": "",
          "testimonial_3_stars": "5",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_4_background_image": null,
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_fan_count_text": "",
          "testimonial_4_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_david.jpg",
          "testimonial_4_name": "David Gold",
          "testimonial_4_redirection_link": "",
          "testimonial_4_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_profile_1745871580146_jw_fitness_hs__25_update_square.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.triplespur.com/triplespurband",
              "stars": "5",
              "fan_count_text": "1.5M Fans",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.triplespur.com/triplespurband",
              "stars": "5",
              "fan_count_text": "1 Million Fans",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": null,
              "stars": "5",
              "fan_count_text": "2M Followers",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": null,
              "stars": "5",
              "fan_count_text": null,
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            }
          ],
          "testimonial_title": "Testimonials",
          "theme_color": "#141515",
          "title": "5",
          "updated_at": 1784616910898,
          "sk": "SECTION#1774250114912"
        }
      ]
    }
  },
  "creators-home": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "background_text_color": "#000000",
      "gsi1sk": "PAGE#1773920158130",
      "updated_at": 1774961570632,
      "status": "PUBLISHED",
      "background_color": "#fffcf2",
      "seoKeywords": "creators, paywall, monetization, platform, subscriptions, premium content, membership, white-labeled",
      "button_text_color": "#ffffff",
      "meta_description": "TopFan is the complete creator monetization platform, providing creators with powerful tools to grow, engage, and monetize your fanbase. Own your data, deepen fan community connections, and build sustainable revenue with subscriptions.",
      "page_id": 1773920158130,
      "gsi1pk": "creators-home",
      "type": "CREATOR_PAGE",
      "pk": "MARKETINGPAGE",
      "title": "Creator Home Page",
      "secondary_background_color": "#000000",
      "meta_title": "White-Labeled Creator Monetization and Paywall",
      "text_color": "#000000",
      "created_at": 1773920158130,
      "post_text_color": "#ffffff",
      "sk": "PAGE#1773920158130",
      "url": "creators-home",
      "sections": [
        {
          "background_color": "#fffcf2",
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "carousel_images": [],
          "created_at": 1774950932203,
          "cta_link": "/creators?watch_sizzle_video=true",
          "cta_text": "Watch Video",
          "layout_id": "image-carousel-layout",
          "page_id": 1773920158130,
          "pk": "PAGE#1773920158130",
          "post_text_color": "#ffffff",
          "poster_url": "https://cdn-www.topfans.com/TopFans/1775136434708.jpg",
          "secondary_background_color": "#050505",
          "section_heading": "{Stop Renting Your Audience.} \\n Own Your Platform. Build Your Empire.",
          "section_id": 1774950932203,
          "sequence_number": 1,
          "subheading": "",
          "theme_color": "#141515",
          "title": "Hero Gif",
          "updated_at": 1775462761259,
          "video_url": "https://cdn-www7.topfans.dev/Posts/PostVideo/TopFan/creator_home_video.mp4",
          "sk": "SECTION#1774950932203"
        },
        {
          "background_color": "#0e0e0e",
          "background_text_color": "#ffffff",
          "button_text_color": "#ffffff",
          "created_at": 1774944111137,
          "creator_poster_1_cta_1": "",
          "creator_poster_1_cta_1_url": "",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_1_description": "No more scattered link-in-bio links, lost fans, or\nfragmented data. Everything you create and sell is in one place via subscription or individual purchase:\\n\n• Videos • Photos • Audio/Podcasts • Courses\n• Newsletters • Livestreams • Merchandise • Tips\n• Personalized Fan Experiences • Paid DMs\n• Downloadables • NFTs & More",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774952098626_frame_2147226081.png",
          "creator_poster_1_title": "{All-in-One Monetization}",
          "creator_poster_2_cta_1": "",
          "creator_poster_2_cta_1_url": "",
          "creator_poster_2_cta_2": "",
          "creator_poster_2_cta_2_url": "",
          "creator_poster_2_description": "Unify all of your fan data in one place with Fan Relationship Management technology. Powerful audience segmentation with consolidated demographic, purchasing and engagement data that you own. Build geo-fenced and targeted SMS text, app push notification, direct message, and email campaigns to grow deeper fan relationships and monetization.",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774952098626_frame_2147226073.png",
          "creator_poster_2_title": "[Data Continuity & Ownership]",
          "creator_poster_3_cta_1": "",
          "creator_poster_3_cta_1_url": "",
          "creator_poster_3_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "creator_poster_3_description": "Your custom Direct-to-Fan platform is made available through your own white-label mobile and desktop website on your own personalized domain name (creatorname.com). Creators also receive a custom branded, white-label iOS & Android mobile app that can receive geo-fenced push notifications. Eliminate platform dependency and build long term equity and future liquidity for yourself.",
          "creator_poster_3_heading_position": "right",
          "creator_poster_3_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774952098626_frame_2147226077__3_.png",
          "creator_poster_3_title": "[Your Platform. Your Brand.]",
          "creator_poster_4_cta_1": "",
          "creator_poster_4_cta_1_url": "",
          "creator_poster_4_cta_2": "",
          "creator_poster_4_cta_2_url": "",
          "creator_poster_4_description": "Most social and paywall platforms reward the already popular Creators, making it difficult for emerging Creators to grow their audiences. TopFan changes that. TopFan’s unique AI-driven discovery helps Creators quickly gain loyal followers and organically acquire new paying fans.",
          "creator_poster_4_heading_position": "left",
          "creator_poster_4_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774960791185_frame_2147226079.png",
          "creator_poster_4_title": "[AI-Driven Fan Discovery]",
          "creator_poster_5_cta_1": "",
          "creator_poster_5_cta_1_url": "",
          "creator_poster_5_cta_2": "",
          "creator_poster_5_cta_2_url": "",
          "creator_poster_5_description": "TopFan is 100% free for Creators and our transparent revenue share model (5-15%) means we only make money when the Creator makes money. Our Creator Success Team is committed to working hands-on with each Creator to develop and execute custom revenue roadmaps.",
          "creator_poster_5_heading_position": "right",
          "creator_poster_5_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774960791186_frame_2147226080.png",
          "creator_poster_5_title": "[Dedication to Creator Success]",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774952098626_frame_2147226081.png",
              "cta_1_url": null,
              "heading_position": "right",
              "cta_2_url": null,
              "description": "No more scattered link-in-bio links, lost fans, or\nfragmented data. Everything you create and sell is in one place via subscription or individual purchase:\\n\n• Videos • Photos • Audio/Podcasts • Courses\n• Newsletters • Livestreams • Merchandise • Tips\n• Personalized Fan Experiences • Paid DMs\n• Downloadables • NFTs & More",
              "cta_2": null,
              "cta_1": null,
              "title": "{All-in-One Monetization}"
            },
            {
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774952098626_frame_2147226073.png",
              "cta_1_url": null,
              "heading_position": "left",
              "cta_2_url": null,
              "description": "Unify all of your fan data in one place with Fan Relationship Management technology. Powerful audience segmentation with consolidated demographic, purchasing and engagement data that you own. Build geo-fenced and targeted SMS text, app push notification, direct message, and email campaigns to grow deeper fan relationships and monetization.",
              "cta_2": null,
              "cta_1": null,
              "title": "[Data Continuity & Ownership]"
            },
            {
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774952098626_frame_2147226077__3_.png",
              "cta_1_url": null,
              "heading_position": "right",
              "cta_2_url": null,
              "description": "Your custom Direct-to-Fan platform is made available through your own white-label mobile and desktop website on your own personalized domain name (creatorname.com). Creators also receive a custom branded, white-label iOS & Android mobile app that can receive geo-fenced push notifications. Eliminate platform dependency and build long term equity and future liquidity for yourself.",
              "cta_2": null,
              "cta_1": null,
              "title": "[Your Platform. Your Brand.]"
            },
            {
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774960791185_frame_2147226079.png",
              "cta_1_url": null,
              "heading_position": "left",
              "cta_2_url": null,
              "description": "Most social and paywall platforms reward the already popular Creators, making it difficult for emerging Creators to grow their audiences. TopFan changes that. TopFan’s unique AI-driven discovery helps Creators quickly gain loyal followers and organically acquire new paying fans.",
              "cta_2": null,
              "cta_1": null,
              "title": "[AI-Driven Fan Discovery]"
            },
            {
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774960791186_frame_2147226080.png",
              "cta_1_url": null,
              "heading_position": "right",
              "cta_2_url": null,
              "description": "TopFan is 100% free for Creators and our transparent revenue share model (5-15%) means we only make money when the Creator makes money. Our Creator Success Team is committed to working hands-on with each Creator to develop and execute custom revenue roadmaps.",
              "cta_2": null,
              "cta_1": null,
              "title": "[Dedication to Creator Success]"
            }
          ],
          "heading_font_size": "large",
          "highlighted_color": "",
          "include_highlighted_border": "true",
          "layout_id": "creator-poster-layout",
          "page_id": 1773920158130,
          "pk": "PAGE#1773920158130",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#050505",
          "section_heading": "Experience the [TopFan] {Difference}",
          "section_id": 1774944111137,
          "sequence_number": 3,
          "subheading": "",
          "theme_color": "#141515",
          "title": "Creator Poster Card",
          "updated_at": 1777284022146,
          "sk": "SECTION#1774944111137"
        },
        {
          "background_color": "#fffcf2",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1775481606340_hero.png",
          "background_text_color": "#000000",
          "button_text_color": "#000000",
          "created_at": 1774264176051,
          "heading_font_size": "medium",
          "layout_id": "vertical-card-carousel-layout",
          "name": "DIRECT-TO-FAN SOLUTIONS FOR EVERY CREATOR",
          "page_id": 1773920158130,
          "pk": "PAGE#1773920158130",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "Direct-To-Fan Solutions for {Every Creator}",
          "section_id": 1774264176051,
          "sequence_number": 5,
          "theme_color": "#000000",
          "title": "Direct-To-Fan Solutions for Every Creator",
          "updated_at": 1780643292310,
          "vertical_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778057758660_fe_hero_mob_mu.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/music-artists",
              "heading": "Music Artists",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779878246150_h_health.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/health-wellness-fitness",
              "heading": "Health, Wellness & Fitness",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779878246150_h_athlete.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/athletes",
              "heading": "Athletes",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777975461366_f_pro_sl.png",
              "cta_text": "Learn More",
              "redirection_link": "/podcasters-journalists-authors",
              "heading": "Podcasters & Journalists",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778759674835_h_s.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/sports-teams-NIL",
              "heading": "Sports Teams & NIL",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779714836340_h_beau.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/beauty-fashion",
              "heading": "Beauty & Fashion",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778759674835_h_e.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/entertainers-performers",
              "heading": "Entertainers & Performers",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778845387987_tv_home_creator.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/film-tv-microdramas",
              "heading": "Film, TV & Microdramas",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779714836340_h_gamer.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/gamers-streamers",
              "heading": "Gamers & Streamers",
              "subheading": ""
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780404710294_h_f_w.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/food-nutrition",
              "heading": "Food & Nutrition",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779449809044_1936.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/politics-movements",
              "heading": "Politics & Movements",
              "subheading": ""
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1780300396206_h_m_o.jpg",
              "cta_text": "Learn More",
              "redirection_link": "/membership-organizations",
              "heading": "Membership Organizations",
              "subheading": ""
            }
          ],
          "verticle_10_cta_text": "Learn More",
          "verticle_10_heading": "Food & Nutrition",
          "verticle_10_image": "https://cdn-www7.topfans.dev/TopFans/Home1780404710294_h_f_w.jpg",
          "verticle_10_redirection_link": "/food-nutrition",
          "verticle_10_subheading": "",
          "verticle_11_cta_text": "Learn More",
          "verticle_11_heading": "Politics & Movements",
          "verticle_11_image": "https://cdn-www.topfans.com/TopFans/Home1779449809044_1936.jpg",
          "verticle_11_redirection_link": "/politics-movements",
          "verticle_11_subheading": "",
          "verticle_12_cta_text": "Learn More",
          "verticle_12_heading": "Membership Organizations",
          "verticle_12_image": "https://cdn-www.topfans.com/TopFans/Home1780300396206_h_m_o.jpg",
          "verticle_12_redirection_link": "/membership-organizations",
          "verticle_12_subheading": "",
          "verticle_1_cta_text": "Learn More",
          "verticle_1_heading": "Music Artists",
          "verticle_1_image": "https://cdn-www.topfans.com/TopFans/Home1778057758660_fe_hero_mob_mu.jpg",
          "verticle_1_redirection_link": "/music-artists",
          "verticle_1_subheading": "",
          "verticle_2_cta_text": "Learn More",
          "verticle_2_heading": "Health, Wellness & Fitness",
          "verticle_2_image": "https://cdn-www.topfans.com/TopFans/Home1779878246150_h_health.jpg",
          "verticle_2_redirection_link": "/health-wellness-fitness",
          "verticle_2_subheading": "",
          "verticle_3_cta_text": "Learn More",
          "verticle_3_heading": "Athletes",
          "verticle_3_image": "https://cdn-www.topfans.com/TopFans/Home1779878246150_h_athlete.jpg",
          "verticle_3_redirection_link": "/athletes",
          "verticle_3_subheading": "",
          "verticle_4_cta_text": "Learn More",
          "verticle_4_heading": "Podcasters & Journalists",
          "verticle_4_image": "https://cdn-www.topfans.com/TopFans/Home1777975461366_f_pro_sl.png",
          "verticle_4_redirection_link": "/podcasters-journalists-authors",
          "verticle_4_subheading": "",
          "verticle_5_cta_text": "Learn More",
          "verticle_5_heading": "Sports Teams & NIL",
          "verticle_5_image": "https://cdn-www.topfans.com/TopFans/Home1778759674835_h_s.jpg",
          "verticle_5_redirection_link": "/sports-teams-NIL",
          "verticle_5_subheading": "",
          "verticle_6_cta_text": "Learn More",
          "verticle_6_heading": "Beauty & Fashion",
          "verticle_6_image": "https://cdn-www.topfans.com/TopFans/Home1779714836340_h_beau.jpg",
          "verticle_6_redirection_link": "/beauty-fashion",
          "verticle_6_subheading": "",
          "verticle_7_cta_text": "Learn More",
          "verticle_7_heading": "Entertainers & Performers",
          "verticle_7_image": "https://cdn-www.topfans.com/TopFans/Home1778759674835_h_e.jpg",
          "verticle_7_redirection_link": "/entertainers-performers",
          "verticle_7_subheading": "",
          "verticle_8_cta_text": "Learn More",
          "verticle_8_heading": "Film, TV & Microdramas",
          "verticle_8_image": "https://cdn-www.topfans.com/TopFans/Home1778845387987_tv_home_creator.jpg",
          "verticle_8_redirection_link": "/film-tv-microdramas",
          "verticle_8_subheading": "",
          "verticle_9_cta_text": "Learn More",
          "verticle_9_heading": "Gamers & Streamers",
          "verticle_9_image": "https://cdn-www.topfans.com/TopFans/Home1779714836340_h_gamer.jpg",
          "verticle_9_redirection_link": "/gamers-streamers",
          "verticle_9_subheading": "",
          "sk": "SECTION#1774264176051"
        },
        {
          "background_color": "#d0e9ee",
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "created_at": 1774266107182,
          "heading_font_size": "medium",
          "layout_id": "testimonial-layout",
          "page_id": 1773920158130,
          "pk": "PAGE#1773920158130",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "Don't take our word for it.\\n {Over 10K+} people trust us.",
          "section_id": 1774266107182,
          "sequence_number": 6,
          "testimonial_1_background_image": null,
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_1_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_profile_1745871580146_jw_fitness_hs__25_update_square.jpg",
          "testimonial_1_name": "John Ward",
          "testimonial_1_redirection_link": "",
          "testimonial_1_stars": "5",
          "testimonial_1_user_name": "johnward",
          "testimonial_2_background_image": null,
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_2_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_julia.jpg",
          "testimonial_2_name": "Julia Julia",
          "testimonial_2_redirection_link": "",
          "testimonial_2_stars": "5",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_3_background_image": null,
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "testimonial_3_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_katrina.jpg",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_3_redirection_link": "",
          "testimonial_3_stars": "5",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_4_background_image": null,
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_david.jpg",
          "testimonial_4_name": "David Gold",
          "testimonial_4_redirection_link": "",
          "testimonial_4_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_profile_1745871580146_jw_fitness_hs__25_update_square.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": null,
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": null,
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": null,
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www6.topfan.dev/Posts/PostsImage/1774268015658_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": null,
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            }
          ],
          "testimonial_title": "Testimonials",
          "theme_color": "#141515",
          "title": "5",
          "updated_at": 1777365161655,
          "sk": "SECTION#1774266107182"
        }
      ]
    }
  },
  "entertainers-performers": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "background_color": "#000000",
      "post_text_color": "#ffffff",
      "seoKeywords": "entertainer fan platform, performer monetization platform, white label creator platform, fan subscription platform, direct-to-fan platform, audience engagement platform, entertainment creator platform, performer membership platform, content monetization platform, entertainer platform",
      "gsi1pk": "entertainers-performers",
      "gsi1sk": "PAGE#1780643762588",
      "pk": "MARKETINGPAGE",
      "meta_title": "White-Label Fan Platform for Entertainers & Performers",
      "status": "PUBLISHED",
      "created_at": 1780643762588,
      "button_text_color": "#ffffff",
      "url": "entertainers-performers",
      "type": "MARKETING_LISTING",
      "meta_description": "Launch your own branded fan platform to engage audiences, sell subscriptions, and monetize exclusive content as an entertainer or performer.",
      "title": "Entertainers & Performers",
      "background_text_color": "#ffffff",
      "secondary_background_color": "#000000",
      "sk": "PAGE#1780643762588",
      "updated_at": 1780643762588,
      "page_id": 1780643762588,
      "text_color": "#000000",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1778828743198_e_home.png",
          "subheading": "Bring Fans Closer to the Entertainment They Love.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "HERO PAGE",
          "page_id": 1780643762588,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Entertain. Engage. Grow.]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643765055,
          "heading_font_size": "large",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643765055,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643765055,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778828743198_e_home_d.png",
          "pk": "PAGE#1780643762588",
          "title": "Hero Page",
          "sk": "SECTION#1780643765055"
        },
        {
          "subheading": "Entertainers building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643767493,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643767493,
          "page_id": 1780643762588,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643767493,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643762588",
          "is_visible": false,
          "title": "Featured Creators",
          "sk": "SECTION#1780643767493"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#f4ecff",
          "name": "BUILD YOUR OWN CREATOR PLATFORM",
          "page_id": 1780643762588,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your {Own Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#ababff",
          "cta_text": "See Example",
          "created_at": 1780643769897,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "updated_at": 1780643769897,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643769897,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778736338323_per_buid.png",
          "pk": "PAGE#1780643762588",
          "title": "Build Your Own Creator Platform",
          "sk": "SECTION#1780643769897"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1779101023641_ep_f2.png",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your audience access to your most valued content - including behind the scenes videos, audio and photos, insightful articles, and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643762588,
          "vcss_2_title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1778736484543_per_f_c1.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643772317,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": null,
          "vcss_3_title": "[In-Person Event Ticketing]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1779101023641_ep_f1.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643772317,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778736484543_per_f_c1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your audience access to your most valued content - including behind the scenes videos, audio and photos, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779101023641_ep_f1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779101023641_ep_f2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[In-Person Event Ticketing]"
            }
          ],
          "section_id": 1780643772317,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643762588",
          "title": "Fan Club",
          "sk": "SECTION#1780643772317"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#f4ecff",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1778236330275_ent_chat_room.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "page_id": 1780643762588,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643774840,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643774840,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778236330275_ent_chat_room.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643774840,
          "creator_poster_1_description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
          "pk": "PAGE#1780643762588",
          "title": "Chat Room",
          "sk": "SECTION#1780643774840"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1779105415_enp_mob_ive.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise during the stream.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "MONETIZE YOUR LIVE STREAMS",
          "page_id": 1780643762588,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643777261,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643777261,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643777261,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1779105415_enp_live.gif",
          "pk": "PAGE#1780643762588",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643777261"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences with Calendar Scheduling}",
          "button_text_color": "#ffffff",
          "background_color": "#ffe7ed",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1778237688377_ent_m2.jpg",
          "page_id": 1780643762588,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780643779652,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778237688377_ent_m1.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778237688377_ent_m2.jpg",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778237688377_ent_m3.jpg",
              "cta_label": "See Example",
              "title": "{Personalized Experiences with Calendar Scheduling}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1778237688377_ent_m3.jpg",
          "pinned_horizontal_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1778237688377_ent_m1.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780643779652,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643779652,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pk": "PAGE#1780643762588",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643779652"
        },
        {
          "subheading": "Get support from your audience and turn your next vision into reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780643782051,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1778238230961_eng_cf_back.png",
          "updated_at": 1780643782051,
          "page_id": 1780643762588,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643782051,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779106295061_ent_cf_1.png",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643762588",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643782051"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643762588,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1778238538636_gamification_bag.png",
          "created_at": 1780643784471,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643784471,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643784471,
          "hero_image": null,
          "pk": "PAGE#1780643762588",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643784471"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1778829155502_e_b_m.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643762588,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643786871,
          "heading_font_size": "medium",
          "background_text_color": "#060606",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643786871,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643786871,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778829155502_e_b_d.png",
          "pk": "PAGE#1780643762588",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "sk": "SECTION#1780643786871"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643762588,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1778833916249_ep_ec_d.png",
          "created_at": 1780643789314,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643789314,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643789314,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778238776893_prof_gam_back.png",
          "pk": "PAGE#1780643762588",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "sk": "SECTION#1780643789314"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1778239500398_eng_tool1.png",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643762588,
          "section_heading": "The Most {Powerful Direct-to-Fan Platform} for Entertainers & Performers",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1778829224257_ent_nw.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643791720,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643791720,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778239500398_eng_tool1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778239923465_eng_tool2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778829224257_ent_nw.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643791720,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1778239923465_eng_tool2.png",
          "pk": "PAGE#1780643762588",
          "title": "More Powerful Tool",
          "sk": "SECTION#1780643791720"
        }
      ]
    }
  },
  "music-artists": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "page_id": 1780643361055,
      "post_text_color": "#ffffff",
      "updated_at": 1781597711149,
      "gsi1sk": "PAGE#1780643361055",
      "status": "PUBLISHED",
      "meta_title": "Music Creator Direct-to-Fan Platform",
      "title": "Music Artists",
      "url": "music-artists",
      "background_color": "#000000",
      "meta_description": "The best direct-to-fan solution for Music Artists.  Sell your music, subscriptions, tickets, livestreams and merch on your own white-labeled platform.",
      "sequence_number": 1,
      "created_at": 1780643361055,
      "text_color": "#000000",
      "pk": "MARKETINGPAGE",
      "button_text_color": "#ffffff",
      "type": "MARKETING_LISTING",
      "secondary_background_color": "#000000",
      "seoKeywords": "Music Creator, Music Artist, Musician, Singer, Direct-to-Fan, Fan Club, Subscription, Membership, App, Monetization, Livestreams, White-Label, Branded Apps",
      "sk": "PAGE#1780643361055",
      "gsi1pk": "music-artists",
      "background_text_color": "#ffffff",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1778057029383_fe_hero_mob_mu.jpg",
          "subheading": "Cut the middleman. Keep the connection.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "YOUR MUSIC. YOUR FANS. YOUR PLATFORM.",
          "page_id": 1780643361055,
          "cta_link": "",
          "section_heading": "[Your Music. \\nYour Fans.]\\nYour Platform.",
          "secondary_background_color": "#002740",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643363479,
          "heading_font_size": "large",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643363479,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643363479,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778057184715_fe_hero_mus_des.jpg",
          "pk": "PAGE#1780643361055",
          "title": "Your Music. Your Fans. Your Platform.",
          "sk": "SECTION#1780643363479"
        },
        {
          "background_color": "#000000",
          "background_image": null,
          "background_text_color": "#ffffff",
          "button_text_color": "#fffcfc",
          "created_at": 1780643365877,
          "featured_creators": [],
          "heading_font_size": "small",
          "layout_id": "feature-creator-layout",
          "name": "FEATURED CREATORS",
          "page_id": 1780643361055,
          "pk": "PAGE#1780643361055",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#232323",
          "section_heading": "[Featured Creators]",
          "section_id": 1780643365877,
          "subheading": "Artists building their audience and income on their own terms.",
          "theme_color": "#ffffff",
          "title": "Featured Creators",
          "updated_at": 1784524349319,
          "sk": "SECTION#1780643365877"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your music and content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#fffcf2",
          "name": "BUILD YOUR OWN CREATOR PLATFORM",
          "page_id": 1780643361055,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.triplespur.com/",
          "section_heading": "Build Your {Own Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by music artists and creators using TopFan white-label technology.",
          "secondary_background_color": "#74309b",
          "cta_text": "See Example",
          "created_at": 1780643368332,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Global music artists and creators trust TopFan for their direct-to-fan monetization and engagement.",
          "seo_content": "TopFan has facilitated over 1000000000 fan engagements for Music Artists.\nMusic Artists have earned over $100M USD using TopFan's white-label technology.\nHundreds of the biggest Music Artists in the world have trusted TopFan for their Direct-to-fan Monetization",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated for Music Artists and Creators.",
          "updated_at": 1780643368332,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643368332,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777466127940_music_build_platform.png",
          "pk": "PAGE#1780643361055",
          "title": "Build Your Own Creator Platform",
          "sk": "SECTION#1780643368332"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "List your tour with Bandsintown integration, with ability to offer unique pre-sale codes via Ticketmaster, AXS and hundreds of other providers.",
          "vcss_2_description": "Sell and distribute your complete catalog of music or stream via DSPs.",
          "vcss_1_description": "Create subscription plans that allow your fans to access exclusive content, pre-sale tickets, merchandise drops, livestreams, giveaways and more.",
          "vcss_4_title": "{Direct Ticket Sales,} VIP and Meet & Greets",
          "vcss_4_cta_2_url": "",
          "vcss_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777030189827_music_fan_club.png",
          "vcss_4_heading_position": "left",
          "vcss_1_cta_1_url": "https://www.triplespur.com/",
          "vcss_4_cta_1_url": "https://www.triplespur.com/",
          "created_at": 1780643370717,
          "background_text_color": "#ffffff",
          "vcss_4_cta_2": "",
          "vcss_4_cta_1": "See Example",
          "vcss_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777030233460_music_fn_ff.png",
          "updated_at": 1780643370717,
          "layout_id": "vertical-card-snap-scroll-layout",
          "section_id": 1780643370717,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_1_title": "[Fan Club Subscriptions] \\nfor Exclusive Content & Access",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643361055",
          "title": "Fan Club",
          "vcss_3_cta_1_url": "https://www.triplespur.com/",
          "vcss_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777293531343_music_fan_club_m.png",
          "name": "FAN CLUB",
          "page_id": 1780643361055,
          "vcss_2_title": "{Direct Sales &}\\n Distribution of Music Albums and Singles",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "vcss_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1776076380886_tickets.png",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1776089048851_gal.png",
          "vcss_3_title": "[Tour Schedules]\\n with Pre-Sale Codes",
          "theme_color": "#ffffff",
          "vcss_2_cta_2_url": "",
          "post_text_color": "#ffffff",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777030189827_music_fan_club.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create subscription plans that allow your fans to access exclusive content, pre-sale tickets, merchandise drops, livestreams, giveaways and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Fan Club Subscriptions] \\nfor Exclusive Content & Access"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777030233460_music_fn_ff.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell and distribute your complete catalog of music or stream via DSPs.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "{Direct Sales &}\\n Distribution of Music Albums and Singles"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777293531343_music_fan_club_m.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "List your tour with Bandsintown integration, with ability to offer unique pre-sale codes via Ticketmaster, AXS and hundreds of other providers.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Tour Schedules]\\n with Pre-Sale Codes"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776076380886_tickets.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell General Admission tickets, VIP Meet & Greets and other special events directly to fans and within your own platform.  Anti-fraud redemption technology is included.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "{Direct Ticket Sales,} VIP and Meet & Greets"
            }
          ],
          "vcss_2_cta_1_url": "https://www.triplespur.com/",
          "vcss_1_heading_position": "left",
          "vcss_4_description": "Sell General Admission tickets, VIP Meet & Greets and other special events directly to fans and within your own platform.  Anti-fraud redemption technology is included.",
          "sk": "SECTION#1780643370717"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#fffcf2",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "section_secondary_background_color": "",
          "creator_poster_1_cta_1_url": "https://www.triplespur.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777464500540_music_chat_room.webp",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "left",
          "creator_poster_1_title": "[Community] Building Tools",
          "page_id": 1780643361055,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643373191,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643373191,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777464500540_music_chat_room.webp",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create a Chat Room for your best fans to safely interact including uploading their photos and videos.  Commenting, Micro-Tipping and Optional Direct Messaging is available too.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community] Building Tools"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643373191,
          "creator_poster_1_description": "Create a Chat Room for your best fans to safely interact including uploading their photos and videos.  Commenting, Micro-Tipping and Optional Direct Messaging is available too.",
          "pk": "PAGE#1780643361055",
          "title": "Chat Room",
          "sk": "SECTION#1780643373191"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1776851588_music_mob_live.gif",
          "subheading": "Host live performances or virtual meet-ups with fans.  Charge for admission, accept tips and sell merch inside the livestream itself.",
          "button_text_color": "#000000",
          "created_at": 1780643375618,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643375618,
          "page_id": 1780643361055,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643375618,
          "cta_link": "https://www.triplespur.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "cta_text_2": "",
          "secondary_background_color": "#002740",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1777541021_mus_live.gif",
          "pk": "PAGE#1780643361055",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Monetize Your Live Stream",
          "sk": "SECTION#1780643375618"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences}",
          "button_text_color": "#ffffff",
          "background_color": "#fffcf2",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATION",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1776262127423_mus_fan.png",
          "page_id": 1780643361055,
          "pinned_horizontal_3_subtitle": "Fans can book 1-on-1 video calls, shout-outs or other personalized fan experiences that you create.  Includes Google and Microsoft Calendar Integration so you never get double booked.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.triplespur.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly to Fans",
          "pinned_horizontal_1_subtitle": "Offer exclusive merchandise drops to fan club members with special discounts.  Seamless integration with Shopify, avoids messy external commerce sites.",
          "created_at": 1780643378062,
          "pinned_horizontal_4_cta_redirection_url": "https://www.triplespur.com/",
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776087497119_merch.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly to Fans",
              "cta_redirection_url": "https://www.triplespur.com/",
              "subtitle": "Offer exclusive merchandise drops to fan club members with special discounts.  Seamless integration with Shopify, avoids messy external commerce sites."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776262127423_mus_fan.png",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.triplespur.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your fans.  Build segments and send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777030367363_music_vertical_meet.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences}",
              "cta_redirection_url": "https://www.triplespur.com/",
              "subtitle": "Fans can book 1-on-1 video calls, shout-outs or other personalized fan experiences that you create.  Includes Google and Microsoft Calendar Integration so you never get double booked."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776087737767_mus.png",
              "cta_label": "See Example",
              "title": "{Music Videos and Episodic Series}",
              "cta_redirection_url": "https://www.triplespur.com/",
              "subtitle": "Distribute and sell your long form videos from your own site and app.  Take your fans on tour with you through an interactive concert video series."
            }
          ],
          "pinned_horizontal_4_title": "{Music Videos and Episodic Series}",
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777030367363_music_vertical_meet.png",
          "pinned_horizontal_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1776087497119_merch.png",
          "pinned_horizontal_4_cta_label": "See Example",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.triplespur.com/",
          "pinned_horizontal_4_subtitle": "Distribute and sell your long form videos from your own site and app.  Take your fans on tour with you through an interactive concert video series.",
          "updated_at": 1780643378062,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643378062,
          "pinned_horizontal_2_cta_redirection_url": "https://www.triplespur.com/",
          "pinned_horizontal_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1776087737767_mus.png",
          "pk": "PAGE#1780643361055",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your fans.  Build segments and send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetization",
          "sk": "SECTION#1780643378062"
        },
        {
          "subheading": "Fund new albums, projects or philanthropic endeavors directly through your fan community.  Give fans gifts for donating.",
          "button_text_color": "#ffffff",
          "created_at": 1780643380463,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1776081525170_backg.png",
          "updated_at": 1780643380463,
          "page_id": 1780643361055,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643380463,
          "content_image": "https://cdn-www7.topfans.dev/TopFans/Home1778669388204_music_cf.png",
          "cta_link": "https://www.triplespur.com/",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643361055",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643380463"
        },
        {
          "subheading": "Make engagement fun for your fans. Reward your supporter's loyalty and online activities with points, virtual badges, and leaderboard rankings that unlock exclusive perks.",
          "button_text_color": "#000000",
          "background_color": "#f5e1b3",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643361055,
          "cta_link": "https://www.triplespur.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#002740",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1777031821210_gamification_bag.png",
          "created_at": 1780643382858,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643382858,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643382858,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1775819264527_b_p_background.png",
          "pk": "PAGE#1780643361055",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643382858"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1777033813722_mob_adss.png",
          "subheading": "Partner with 3rd party brands to display advertisements and special offers.  You control any advertising that is displayed and get paid directly.",
          "button_text_color": "#ffffff",
          "background_color": "#d1eff8",
          "name": "BRAND SPONSORSHIP",
          "page_id": 1780643361055,
          "cta_link": "https://www.triplespur.com/",
          "section_heading": "{Brand Sponsorship}\\n Advertising & VIP \\nDiscount Offers",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643385266,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643385266,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643385266,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777033813721_mu_adds.png",
          "pk": "PAGE#1780643361055",
          "title": "Brand Sponsorship",
          "sk": "SECTION#1780643385266"
        },
        {
          "subheading": "Create and sell an e-course on making music or learning an instrument. Offer electronic downloads like sheet music.",
          "button_text_color": "#000000",
          "background_color": "#010101",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643361055,
          "cta_link": "https://www.triplespur.com/",
          "section_heading": "Monetize Your Expertise \\n with [eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#002740",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1777545787245_feed_skills.png",
          "created_at": 1780643387668,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643387668,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643387668,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1775818993264_b_p_background.png",
          "pk": "PAGE#1780643361055",
          "title": "Monetize Your Expertise eCourses & Downloadables",
          "sk": "SECTION#1780643387668"
        },
        {
          "creator_poster_4_title": "[Community Chat Rooms]",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1775820054985_go_global.png",
          "creator_poster_3_cta_1_url": "https://www.triplespur.com/",
          "creator_poster_1_title": "Build a [Global Audience]",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643390052,
          "background_text_color": "#000000",
          "creator_poster_2_cta_2": "",
          "updated_at": 1780643390052,
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775820054985_go_global.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 languages and accepts 50+ currencies with localized pricing adjustments.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Build a [Global Audience]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777980167231_f_lib_m.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links. Sell directly inside TikTok and Instagram, with a free Link in Bio micro-site that has all your courses, livestreams, event tickets, merch, and content embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775820054985_create_paid_newsletters.png",
              "cta_1_url": "https://www.triplespur.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Build a database of fans and proactively send them free or locked newsletters content by email.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Create Premium {Newsletters}"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643390052,
          "creator_poster_2_cta_1_url": "https://www.triplespur.com/",
          "creator_poster_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777980167231_f_lib_m.png",
          "pk": "PAGE#1780643361055",
          "title": "More Powerful Tool",
          "subheading": "TopFan eliminates the need for tens of expensive creator tools, bringing everything together in one place for a seamless fan experience.",
          "creator_poster_4_cta_2_url": "",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.triplespur.com/",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_heading_position": "right",
          "page_id": 1780643361055,
          "section_heading": "The Most Powerful {Direct-To-Fan Platform} for Musicians",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_4_cta_1": "See Example",
          "creator_poster_4_cta_2": "",
          "creator_poster_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1775820054985_create_paid_newsletters.png",
          "creator_poster_2_heading_position": "left",
          "heading_font_size": "medium",
          "creator_poster_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1777032807628_tool_chat_room.png",
          "creator_poster_3_title": "Create Premium {Newsletters}",
          "theme_color": "#ffffff",
          "creator_poster_3_cta_2_url": "",
          "post_text_color": "#ffffff",
          "creator_poster_4_cta_1_url": "https://www.triplespur.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 languages and accepts 50+ currencies with localized pricing adjustments.",
          "creator_poster_2_description": "No more fragmented 3rd party links. Sell directly inside TikTok and Instagram, with a free Link in Bio micro-site that has all your courses, livestreams, event tickets, merch, and content embedded.",
          "creator_poster_3_description": "Build a database of fans and proactively send them free or locked newsletters content by email.",
          "creator_poster_4_heading_position": "left",
          "creator_poster_4_description": "Create a safe place for your best fans to interact with each other by uploading their photos and videos from your tours.",
          "sk": "SECTION#1780643390052"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffebff",
          "testimonial_4_creator_type": "Musicians",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042025_add.webp",
          "testimonial_2_user_name": "triplespurband",
          "testimonial_4_stars": "5",
          "testimonial_2_content": "TopFan made growing my fanbase feel natural and exciting. I’ve connected with listeners who consistently support my releases, and that keeps me inspired. The platform is simple, smooth, and focused on creators. It’s more than just sharing music—it’s about building lasting relationships with people who love your sound.",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042024_parda.webp",
          "testimonial_title": "Testimonials",
          "created_at": 1780643392445,
          "testimonial_4_background_image": null,
          "testimonial_1_user_name": "badbunny",
          "background_text_color": "#000000",
          "updated_at": 1780643392445,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042025_tirpe.png",
          "layout_id": "testimonial-layout",
          "section_id": 1780643392445,
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "mikayla-geier",
          "testimonial_2_redirection_link": "",
          "pk": "PAGE#1780643361055",
          "is_visible": true,
          "title": "Testimonials",
          "testimonial_3_name": "LUXYN",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "",
          "testimonial_3_user_name": "luxyn",
          "testimonial_3_content": "As an independent artist, TopFan gives me the space to express myself freely. I love how I can directly interact with fans who truly appreciate my work. The engagement feels authentic, and it motivates me to keep creating. It’s refreshing to use a platform that actually puts creators first",
          "page_id": 1780643361055,
          "testimonial_3_background_image": null,
          "section_heading": "TopFan has been trusted by the {biggest} music artists in the world since 2015.",
          "testimonial_4_redirection_link": "",
          "testimonial_2_background_image": null,
          "testimonial_1_content": "TopFan has transformed how I share my music. I’m finally reaching listeners who genuinely connect with my sound. The platform makes it easy to upload tracks and engage with fans in a meaningful way. It feels less about chasing numbers and more about building a real, supportive community around my music.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Triple Spur Band",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042024_parda.webp",
              "creator_type": "Musicians",
              "user_name": "badbunny",
              "name": "Pedros",
              "redirection_link": "",
              "stars": "5",
              "content": "TopFan has transformed how I share my music. I’m finally reaching listeners who genuinely connect with my sound. The platform makes it easy to upload tracks and engage with fans in a meaningful way. It feels less about chasing numbers and more about building a real, supportive community around my music."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042025_tirpe.png",
              "creator_type": "Musicians",
              "user_name": "triplespurband",
              "name": "Triple Spur Band",
              "redirection_link": "",
              "stars": "5",
              "content": "TopFan made growing my fanbase feel natural and exciting. I’ve connected with listeners who consistently support my releases, and that keeps me inspired. The platform is simple, smooth, and focused on creators. It’s more than just sharing music—it’s about building lasting relationships with people who love your sound."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042025_lux.webp",
              "creator_type": "Musicians",
              "user_name": "luxyn",
              "name": "LUXYN",
              "redirection_link": "",
              "stars": "5",
              "content": "As an independent artist, TopFan gives me the space to express myself freely. I love how I can directly interact with fans who truly appreciate my work. The engagement feels authentic, and it motivates me to keep creating. It’s refreshing to use a platform that actually puts creators first"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042025_add.webp",
              "creator_type": "Musicians",
              "user_name": "mikayla-geier",
              "name": "Mikayla Geier",
              "redirection_link": "",
              "stars": "5",
              "content": "Since joining TopFan, my music has found a more engaged audience. The feedback I get is real and helps me improve as an artist. I enjoy being able to connect directly with my fans and share my journey with them. It’s a platform that truly understands what creators need."
            }
          ],
          "testimonial_1_redirection_link": "",
          "testimonial_3_stars": "5",
          "testimonial_1_name": "Pedros",
          "testimonial_4_content": "Since joining TopFan, my music has found a more engaged audience. The feedback I get is real and helps me improve as an artist. I enjoy being able to connect directly with my fans and share my journey with them. It’s a platform that truly understands what creators need.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1775821042025_lux.webp",
          "theme_color": "#000000",
          "post_text_color": "#ffffff",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "Mikayla Geier",
          "testimonial_1_creator_type": "Musicians",
          "testimonial_3_creator_type": "Musicians",
          "sk": "SECTION#1780643392445"
        }
      ]
    }
  },
  "sports-teams-NIL": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "background_color": "#000000",
      "post_text_color": "#ffffff",
      "meta_description": "Launch your own branded fan platform for sports teams. Engage fans, sell subscriptions, and monetize content with a powerful white-label solution.",
      "gsi1pk": "sports-teams-NIL",
      "pk": "MARKETINGPAGE",
      "sk": "PAGE#1780643626514",
      "status": "PUBLISHED",
      "title": "Sports Teams & NIL",
      "updated_at": 1780643626514,
      "page_id": 1780643626514,
      "button_text_color": "#ffffff",
      "type": "MARKETING_LISTING",
      "meta_title": "Sports Teams | Build & Monetize Your Fanbase",
      "gsi1sk": "PAGE#1780643626514",
      "seoKeywords": "white label, sports team platform, sports fan platform, team fan engagement platform, sports monetization platform, fan subscription platform, build your own sports app, fan community platform, monetize sports audience, direct-to-fan platform, sports membership platform",
      "url": "sports-teams-NIL",
      "background_text_color": "#ffffff",
      "secondary_background_color": "#000000",
      "created_at": 1780643626514,
      "text_color": "#000000",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1777636051396_sports_hero_mobile.png",
          "subheading": "Engage your fan base, share exclusive content, and build consistent direct-to-fan revenue for your team.",
          "button_text_color": "#000000",
          "created_at": 1780643628969,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643628969,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643628969,
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "[Play. Inspire. Earn.]",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777634679471_sports_hero.png",
          "pk": "PAGE#1780643626514",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Sports Teams Hero Page",
          "sk": "SECTION#1780643628969"
        },
        {
          "subheading": "Experts building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643631539,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643631539,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643631539,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643626514",
          "is_visible": false,
          "title": "Featured Creators",
          "sk": "SECTION#1780643631539"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#cfebfd",
          "page_id": 1780643626514,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "Build Your Own {Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#ffdbbd",
          "cta_text": "See Example",
          "created_at": 1780643633926,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "updated_at": 1780643633926,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643633926,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777636576462_sports_build.png",
          "pk": "PAGE#1780643626514",
          "title": "Build Your Own Creator Platform",
          "sk": "SECTION#1780643633926"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
          "vcss_3_cta_1_url": "https://www.gohawks.org/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1777980676013_f_sport_1.png",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your fans access to your most valued content - including behind the scenes access,  videos, photo galleries, insightful articles, and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643626514,
          "vcss_2_title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1777878054325_f_ath_fan_club_s.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.gohawks.org/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643636327,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1777637890612_prof_fan_back.png",
          "vcss_3_title": "In-Person {Event Ticketing]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1778058345885_fe_direct_sale_sports.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643636327,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777878054325_f_ath_fan_club_s.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your fans access to your most valued content - including behind the scenes access,  videos, photo galleries, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778058345885_fe_direct_sale_sports.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777980676013_f_sport_1.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "In-Person {Event Ticketing]"
            }
          ],
          "section_id": 1780643636327,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.gohawks.org/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643626514",
          "title": "Fan Club",
          "sk": "SECTION#1780643636327"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#cfebfd",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.gohawks.org/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1777638131294_sports_chat_room.png",
          "creator_poster_1_heading_position": "left",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "page_id": 1780643626514,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643638767,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643638767,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777638131294_sports_chat_room.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643638767,
          "creator_poster_1_description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
          "pk": "PAGE#1780643626514",
          "title": "Chat Room",
          "sk": "SECTION#1780643638767"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1777874821f_mob_spo.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise and tickets during the stream.",
          "button_text_color": "#000000",
          "created_at": 1780643641145,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643641145,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643641145,
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1777874737_f_des_spo.gif",
          "pk": "PAGE#1780643626514",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643641145"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences} with Calendar Scheduling",
          "button_text_color": "#ffffff",
          "background_color": "#ffebff",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1777982434827_f_2_frm.jpg",
          "page_id": 1780643626514,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.gohawks.org/",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780643643541,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777638522166_sports_hr1.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.gohawks.org/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777982434827_f_2_frm.jpg",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.gohawks.org/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777982434828_f_1_sch.jpg",
              "cta_label": "See Example",
              "title": "{Personalized Experiences} with Calendar Scheduling",
              "cta_redirection_url": "https://www.gohawks.org/",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1777982434828_f_1_sch.jpg",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1777638522166_sports_hr1.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.gohawks.org/",
          "updated_at": 1780643643541,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643643541,
          "pinned_horizontal_2_cta_redirection_url": "https://www.gohawks.org/",
          "pk": "PAGE#1780643626514",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643643541"
        },
        {
          "subheading": "Utilize built-in crowdfunding technology to raise money for projects and philanthropic efforts.",
          "button_text_color": "#ffffff",
          "created_at": 1780643645962,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1777638664567_sports_fund_back.png",
          "updated_at": 1780643645962,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643645962,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1778669591011_sport_c_f.png",
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "{Team Up} for a Cause",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643626514",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643645962"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1777638819069_gamification_bag.png",
          "button_text_color": "#000000",
          "created_at": 1780643648345,
          "background_color": "#eaf0e2",
          "heading_font_size": "medium",
          "include_highlighted_border": "false",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643648345,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643648345,
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777638819068_prof_gam_back.png",
          "pk": "PAGE#1780643626514",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643648345"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1777638923560_sports_brand_mob.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "created_at": 1780643650760,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643650760,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643650760,
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777638923560_sports_brans_ad.png",
          "pk": "PAGE#1780643626514",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "sk": "SECTION#1780643650760"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1777639383913_sports_courses.png",
          "button_text_color": "#000000",
          "created_at": 1780643653262,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "include_highlighted_border": "false",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643653262,
          "page_id": 1780643626514,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643653262,
          "cta_link": "https://www.gohawks.org/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777639383912_prof_gam_back.png",
          "pk": "PAGE#1780643626514",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "sk": "SECTION#1780643653262"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.gohawks.org/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "true",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1777640232049_sports_tool_1.png",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.gohawks.org/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643626514,
          "section_heading": "The Most Powerful {Direct-to-Fan Platform} for Teams",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1777640232049_sports_tool_3.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643655869,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643655869,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777640232049_sports_tool_1.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777980213979_f_lib_sports.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777640232049_sports_tool_3.png",
              "cta_1_url": "https://www.gohawks.org/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643655869,
          "creator_poster_2_cta_1_url": "https://www.gohawks.org/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1777980213979_f_lib_sports.png",
          "pk": "PAGE#1780643626514",
          "title": "More Powerful Tool",
          "sk": "SECTION#1780643655869"
        }
      ]
    }
  },
  "podcasters-journalists-authors": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "page_id": 1780643580923,
      "updated_at": 1780643580923,
      "sk": "PAGE#1780643580923",
      "seoKeywords": "white label podcast platform, creator monetization Professionals Platform, fan subscription platform, build your own fan platform, content monetization platform, fan engagement platform, subscription platform for creators,  creator economy platform, paid content platform, journalist",
      "meta_description": "Launch your own content platform with direct-to-fan engagement and monetization on your own white-labeled app and website.",
      "background_color": "#000000",
      "pk": "MARKETINGPAGE",
      "status": "PUBLISHED",
      "url": "podcasters-journalists-authors",
      "post_text_color": "#ffffff",
      "meta_title": "White-Label Platform for Podcasters, Journalists & Authors",
      "background_text_color": "#ffffff",
      "created_at": 1780643580923,
      "secondary_background_color": "#000000",
      "type": "MARKETING_LISTING",
      "text_color": "#000000",
      "title": "Podcasters & Journalists",
      "gsi1pk": "podcasters-journalists-authors",
      "button_text_color": "#ffffff",
      "gsi1sk": "PAGE#1780643580923",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1777975267552_f_pro_hero_mob.jpg",
          "subheading": "Turn Your Expertise Into an Ecosystem",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "PROFESSIONALS HERO PAGE",
          "page_id": 1780643580923,
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "[Share Knowledge.] \\n Build Income.",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643583401,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643583401,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643583401,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777975267552_f_pro_des_hero.jpg",
          "pk": "PAGE#1780643580923",
          "title": "Professionals Hero Page",
          "sk": "SECTION#1780643583401"
        },
        {
          "subheading": "Experts building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643585837,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643585837,
          "page_id": 1780643580923,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643585837,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643580923",
          "is_visible": false,
          "title": "Featured Creators",
          "sk": "SECTION#1780643585837"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#fffcf2",
          "page_id": 1780643580923,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "Build Your Own {Audience Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#74309b",
          "cta_text": "See Example",
          "created_at": 1780643588253,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Global creators trust TopFan for their direct-to-fan monetization and engagement.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated for creators.",
          "updated_at": 1780643588253,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643588253,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777632186496_prof_build_your_own.png",
          "pk": "PAGE#1780643580923",
          "title": "Build Your Own Creator Platform",
          "sk": "SECTION#1780643588253"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Host In Real Life workshops and live events. Sell tickets with different tiers, VIP access, from inside your own powerful platform.",
          "vcss_3_cta_1_url": "https://www.bondedwealth.com/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1777632499806_prof_fan_ticket.png",
          "vcss_2_description": "Offer paid access to your sessions, video series, and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your audience access to your most valued content - including guided coaching, videos, podcasts, insightful articles, and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643580923,
          "vcss_2_title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1777632499805_prof_fan_sub.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.bondedwealth.com/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643590654,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1777632380551_prof_fan_back.png",
          "vcss_3_title": "[In-Person Event Ticketing]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1777973236237_f_pro_po.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643590654,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777632499805_prof_fan_sub.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your audience access to your most valued content - including guided coaching, videos, podcasts, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777973236237_f_pro_po.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your sessions, video series, and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777632499806_prof_fan_ticket.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Host In Real Life workshops and live events. Sell tickets with different tiers, VIP access, from inside your own powerful platform.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[In-Person Event Ticketing]"
            }
          ],
          "section_id": 1780643590654,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.bondedwealth.com/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643580923",
          "title": "Fan Club",
          "sk": "SECTION#1780643590654"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#fffcf2",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.bondedwealth.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1777632867296_prof_chat_room.png",
          "creator_poster_1_heading_position": "left",
          "creator_poster_1_title": "[Build a Strong Community]",
          "page_id": 1780643580923,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643593072,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643593072,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777632867296_prof_chat_room.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create a safe space for your most loyal audience members to interact with each other, and enable member direct messaging to build connections.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Build a Strong Community]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643593072,
          "creator_poster_1_description": "Create a safe space for your most loyal audience members to interact with each other, and enable member direct messaging to build connections.",
          "pk": "PAGE#1780643580923",
          "title": "Chat Room",
          "sk": "SECTION#1780643593072"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1777874593_f_mob_pro.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise and e-courses during the stream.",
          "button_text_color": "#000000",
          "created_at": 1780643595480,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643595480,
          "page_id": 1780643580923,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643595480,
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1777874530_f_des_pro.gif",
          "pk": "PAGE#1780643580923",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643595480"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences with Calendar Scheduling}",
          "button_text_color": "#ffffff",
          "background_color": "#fff2e5",
          "pinned_horizontal_1_cta_label": "See Example",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1777633552835_prof_hr2.png",
          "page_id": 1780643580923,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.bondedwealth.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly On Your Platform",
          "pinned_horizontal_1_subtitle": "Offer exclusive merchandise to your audience via your store on your own site with a seamless Shopify integration.",
          "created_at": 1780643597917,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777633552835_prof_hr1.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly On Your Platform",
              "cta_redirection_url": "https://www.bondedwealth.com/",
              "subtitle": "Offer exclusive merchandise to your audience via your store on your own site with a seamless Shopify integration."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777633552835_prof_hr2.png",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.bondedwealth.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777633552835_prof_hr_3.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences with Calendar Scheduling}",
              "cta_redirection_url": "https://www.bondedwealth.com/",
              "subtitle": "Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1777633552835_prof_hr_3.png",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1777633552835_prof_hr1.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.bondedwealth.com/",
          "updated_at": 1780643597917,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643597917,
          "pinned_horizontal_2_cta_redirection_url": "https://www.bondedwealth.com/",
          "pk": "PAGE#1780643580923",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643597917"
        },
        {
          "subheading": "Get support from your audience and turn your professional vision into reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780643600309,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1777633947173_prof_cf_back.png",
          "updated_at": 1780643600309,
          "page_id": 1780643580923,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643600309,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1777633947173_prof_crow_midd.png",
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "{Fund} Your Next Big Idea",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643580923",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643600309"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1777634325020_gamification_bag.png",
          "button_text_color": "#000000",
          "created_at": 1780643602709,
          "background_color": "#eaf0e2",
          "heading_font_size": "medium",
          "include_highlighted_border": "false",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643602709,
          "page_id": 1780643580923,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643602709,
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777634325020_prof_gam_back.png",
          "pk": "PAGE#1780643580923",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643602709"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1777634924265_prof_brand_mob.png",
          "subheading": "Earn money from brands and earn through ads or special offers for your fans. You control the ad network.",
          "button_text_color": "#ffffff",
          "created_at": 1780643605107,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643605107,
          "page_id": 1780643580923,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643605107,
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777543007893_prof_brand.png",
          "pk": "PAGE#1780643580923",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "sk": "SECTION#1780643605107"
        },
        {
          "subheading": "Package your expertise into premium courses and downloadable content to create new income streams.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643580923,
          "cta_link": "https://www.bondedwealth.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1777989061156_fe_pro.png",
          "created_at": 1780643607504,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643607504,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643607504,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777635264785_prof_gam_back.png",
          "pk": "PAGE#1780643580923",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "sk": "SECTION#1780643607504"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.bondedwealth.com/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "true",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1777635772816_prof_tool_1.png",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.bondedwealth.com/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643580923,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1777635772817_prof_tool_3.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643609909,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643609909,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777635772816_prof_tool_1.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with local pricing (cost-of-living) optimization.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777974477413_f_pro_lib.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with an embeddable Link in Bio that has all your courses, livestreams, event tickets, merch, and exclusive content.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1777635772817_prof_tool_3.png",
              "cta_1_url": "https://www.bondedwealth.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your site and receive you latest news, events and merchandise information. There is no cost to send newsletters.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643609909,
          "creator_poster_2_cta_1_url": "https://www.bondedwealth.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with local pricing (cost-of-living) optimization.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with an embeddable Link in Bio that has all your courses, livestreams, event tickets, merch, and exclusive content.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your site and receive you latest news, events and merchandise information. There is no cost to send newsletters.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1777974477413_f_pro_lib.png",
          "pk": "PAGE#1780643580923",
          "title": "More Powerful Tool",
          "sk": "SECTION#1780643609909"
        }
      ]
    }
  },
  "gamers-streamers": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "background_color": "#000000",
      "url": "gamers-streamers",
      "post_text_color": "#ffffff",
      "meta_title": "White-Label Fan Platform for Gamers & Streamers",
      "updated_at": 1780643853283,
      "page_id": 1780643853283,
      "meta_description": "Launch your own branded gaming platform on web and mobile apps to live stream content, engage fans, monetize your audience, and grow your gaming community.",
      "sk": "PAGE#1780643853283",
      "pk": "MARKETINGPAGE",
      "status": "PUBLISHED",
      "button_text_color": "#ffffff",
      "type": "MARKETING_LISTING",
      "gsi1sk": "PAGE#1780643853283",
      "gsi1pk": "gamers-streamers",
      "created_at": 1780643853283,
      "background_text_color": "#ffffff",
      "secondary_background_color": "#000000",
      "seoKeywords": "gaming creator platform, streamer monetization platform, gamer fan platform, white label streaming platform, gaming subscription platform, direct-to-fan gaming platform, gaming community platform, streamer fan engagement, gaming content monetization, platform for gamers and streamers",
      "title": "Gamers & Streamers",
      "text_color": "#000000",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779362917212_gs_hero_mob.png",
          "subheading": "Turn Viewers Into Superfans.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "HERO PAGE",
          "page_id": 1780643853283,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Your Audience. \\nYour Arena.]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643855745,
          "heading_font_size": "large",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643855745,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643855745,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779362968216_gs_hero_des.png",
          "pk": "PAGE#1780643853283",
          "title": "Hero Page",
          "sk": "SECTION#1780643855745"
        },
        {
          "subheading": "Experts building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643858144,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643858144,
          "page_id": 1780643853283,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643858144,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643853283",
          "is_visible": false,
          "title": "Featured Creators",
          "sk": "SECTION#1780643858144"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#ffecfe",
          "name": "BUILD YOUR OWN FAN ENGAGEMENT PLATFORM",
          "page_id": 1780643853283,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your Own {Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#ababff",
          "cta_text": "See Example",
          "created_at": 1780643860546,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "updated_at": 1780643860546,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643860546,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779363097388_gs_build_plat.png",
          "pk": "PAGE#1780643853283",
          "title": "Build Your Own Fan Engagement Platform",
          "sk": "SECTION#1780643860546"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Sell tickets to online and IRL events from your own powerful platform.",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1779363328106_gs_fc_3.png",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every viewer.",
          "vcss_1_description": "Create membership plans and give your fans access to your most valued content - including behind the scenes access,  videos, photo galleries, insightful articles, and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643853283,
          "vcss_2_title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1779363328106_gs_fc_1.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643862973,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1779363790145_gs_back.png",
          "vcss_3_title": "In-Person [Event Ticketing]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1779713462221_gs_mone.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643862973,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779363328106_gs_fc_1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your fans access to your most valued content - including behind the scenes access,  videos, photo galleries, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779713462221_gs_mone.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779363328106_gs_fc_3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to online and IRL events from your own powerful platform.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "In-Person [Event Ticketing]"
            }
          ],
          "section_id": 1780643862973,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643853283",
          "title": "Fan Club",
          "sk": "SECTION#1780643862973"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#cfebfd",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779363836480_gs_link_in_bio.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "page_id": 1780643853283,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643865395,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643865395,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779363836480_gs_link_in_bio.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643865395,
          "creator_poster_1_description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
          "pk": "PAGE#1780643853283",
          "title": "Chat Room",
          "sk": "SECTION#1780643865395"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1779369815_gs_lives_mob.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise and tickets during the stream.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "LIVE STREAM",
          "page_id": 1780643853283,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643867808,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643867808,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643867808,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1779369815_gs_lives_desc.gif",
          "pk": "PAGE#1780643853283",
          "title": "Live Stream",
          "sk": "SECTION#1780643867808"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences} with Calendar Scheduling",
          "button_text_color": "#ffffff",
          "background_color": "#ffebeb",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1779367821301_gs_m2.jpg",
          "page_id": 1780643853283,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780643870336,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779714138993_gs_h.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779367821301_gs_m2.jpg",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779364062021_gs_m3.jpg",
              "cta_label": "See Example",
              "title": "{Personalized Experiences} with Calendar Scheduling",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1779364062021_gs_m3.jpg",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1779714138993_gs_h.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780643870336,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643870336,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pk": "PAGE#1780643853283",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643870336"
        },
        {
          "subheading": "Get support from your audience and turn your next gaming or streaming project into a reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780643872795,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1779370461624_gs_back.webp",
          "updated_at": 1780643872795,
          "page_id": 1780643853283,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643872795,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779713417412_gs_df.png",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643853283",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643872795"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643853283,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1777638819069_gamification_bag.png",
          "created_at": 1780643875224,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643875224,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643875224,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777638819068_prof_gam_back.png",
          "pk": "PAGE#1780643853283",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643875224"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779369621159_gs_brand_mob.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643853283,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643877806,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643877806,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643877806,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779369621159_gs_brand_des.png",
          "pk": "PAGE#1780643853283",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "sk": "SECTION#1780643877806"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643853283,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1779368414335_gs_co_down.png",
          "created_at": 1780643880273,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643880273,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643880273,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777639383912_prof_gam_back.png",
          "pk": "PAGE#1780643853283",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "sk": "SECTION#1780643880273"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool1.png",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643853283,
          "section_heading": "The Most Powerful {Direct-to-Fan Platform} for Gamers",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool3.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643882699,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643882699,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643882699,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool2.png",
          "pk": "PAGE#1780643853283",
          "title": "More Powerful Tool",
          "sk": "SECTION#1780643882699"
        }
      ]
    }
  },
  "film-tv-microdramas": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "button_text_color": "#ffffff",
      "gsi1pk": "film-tv-microdramas",
      "page_id": 1780643808068,
      "sk": "PAGE#1780643808068",
      "background_text_color": "#ffffff",
      "updated_at": 1780643808068,
      "secondary_background_color": "#000000",
      "status": "PUBLISHED",
      "meta_title": "White-Label Fan Platform for Film & Television Properties",
      "text_color": "#000000",
      "pk": "MARKETINGPAGE",
      "gsi1sk": "PAGE#1780643808068",
      "background_color": "#000000",
      "post_text_color": "#ffffff",
      "seoKeywords": "film creator platform, television creator platform, film and TV monetization, white label fan platform, entertainment subscription platform, direct-to-fan platform, fan engagement platform, creator monetization platform, film and television platform, content monetization platform",
      "created_at": 1780643808068,
      "type": "MARKETING_LISTING",
      "url": "film-tv-microdramas",
      "meta_description": "Launch your own branded platform to engage fans, share exclusive content, sell subscriptions, and monetize your film and television audience.",
      "title": "Film, TV & Microdramas",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1778836788999_tv_h_m.png",
          "subheading": "Bring Your Stories Directly to Your Audience",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "BEAUTY AND MAKEUP HERO PAGE",
          "page_id": 1780643808068,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Lights. Camera. Revenue.}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643810553,
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643810553,
          "post_text_color": "#000000",
          "layout_id": "hero-layout",
          "section_id": 1780643810553,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/gif/tv_home_page.gif",
          "pk": "PAGE#1780643808068",
          "title": "Beauty and Makeup Hero Page",
          "sk": "SECTION#1780643810553"
        },
        {
          "subheading": "Franchises building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643812964,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643812964,
          "page_id": 1780643808068,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643812964,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643808068",
          "is_visible": false,
          "title": "Featured Creators",
          "sk": "SECTION#1780643812964"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#ffecfe",
          "name": "BUILD YOUR OWN FAN ENGAGEMENT PLATFORM",
          "page_id": 1780643808068,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your {Own Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#000000",
          "cta_text": "See Example",
          "created_at": 1780643815358,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "updated_at": 1780643815358,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643815358,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779968938238_tv_b_p.png",
          "pk": "PAGE#1780643808068",
          "title": "Build Your Own Fan Engagement Platform",
          "sk": "SECTION#1780643815358"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Deliver short-form microdrama series in the vertical format, that captivate audiences and drive engagement from every episode.",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.  Support for vertical videos and micro-dramas.",
          "vcss_1_description": "Create membership plans and give your audience access to your most valued content - including behind the scenes videos, audio and photos, insightful articles, and personalized experiences.",
          "vcss_4_title": "[In-Person Event Ticketing]",
          "vcss_4_cta_2_url": "",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1779101487608_tv_m_2.png",
          "vcss_4_heading_position": "left",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_4_cta_1_url": "https://www.balancewithsienna.com/",
          "created_at": 1780643817768,
          "background_text_color": "#ffffff",
          "vcss_4_cta_2": "",
          "vcss_4_cta_1": "See Example",
          "vcss_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1778838309644_tv_fc_2.png",
          "updated_at": 1780643817768,
          "layout_id": "vertical-card-snap-scroll-layout",
          "section_id": 1780643817768,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643808068",
          "title": "Fan Club",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780308680591_tv_drama.png",
          "name": "FAN CLUB",
          "page_id": 1780643808068,
          "vcss_2_title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "vcss_4_image": "https://cdn-www.topfans.com/TopFans/Home1779963149377_1779101487609_tv_m_3.webp",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778838187567_tv_f_back.png",
          "vcss_3_title": "[Micro Drama,\\n Macro Impact]",
          "theme_color": "#ffffff",
          "vcss_2_cta_2_url": "",
          "post_text_color": "#ffffff",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779101487608_tv_m_2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your audience access to your most valued content - including behind the scenes videos, audio and photos, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778838309644_tv_fc_2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.  Support for vertical videos and micro-dramas.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780308680591_tv_drama.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Deliver short-form microdrama series in the vertical format, that captivate audiences and drive engagement from every episode.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Micro Drama,\\n Macro Impact]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779963149377_1779101487609_tv_m_3.webp",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[In-Person Event Ticketing]"
            }
          ],
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_4_description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
          "sk": "SECTION#1780643817768"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#fff4ec",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779191462128_tv_m_chat_room.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "page_id": 1780643808068,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643820175,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643820175,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779191462128_tv_m_chat_room.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643820175,
          "creator_poster_1_description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
          "pk": "PAGE#1780643808068",
          "title": "Chat Room",
          "sk": "SECTION#1780643820175"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1778834881_tv_li_m.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise during the stream.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "MONETIZE YOUR LIVE STREAMS",
          "page_id": 1780643808068,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643822682,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643822682,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643822682,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1779265847_tv_lives_desc.gif",
          "pk": "PAGE#1780643808068",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643822682"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences with Calendar Scheduling}",
          "button_text_color": "#ffffff",
          "background_color": "#ffebff",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1779101743626_tv_m_6.jpg",
          "page_id": 1780643808068,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780643825087,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779191532970_tv_m_monetization1.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779101743626_tv_m_6.jpg",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778841726317_tv_m3.jpg",
              "cta_label": "See Example",
              "title": "{Personalized Experiences with Calendar Scheduling}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1778841726317_tv_m3.jpg",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1779191532970_tv_m_monetization1.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780643825087,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643825087,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pk": "PAGE#1780643808068",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643825087"
        },
        {
          "subheading": "Get support from your audience and turn your next film or television project into a reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780643827486,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1778841943245_tv_cf_b.png",
          "updated_at": 1780643827486,
          "page_id": 1780643808068,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643827486,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779191570961_tv_m_crowd_funding.png",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643808068",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643827486"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643808068,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1778839545276_gamification_bag.png",
          "created_at": 1780643829918,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643829918,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643829918,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778839545275_prof_gam_back.png",
          "pk": "PAGE#1780643808068",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643829918"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1778842626329_tv_b_m.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643808068,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643832315,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643832315,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643832315,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778842626329_tv_b_d.png",
          "pk": "PAGE#1780643808068",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "sk": "SECTION#1780643832315"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643808068,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1778842525231_tv_c_d.png",
          "created_at": 1780643834750,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643834750,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643834750,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778839859992_prof_gam_back.png",
          "pk": "PAGE#1780643808068",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "sk": "SECTION#1780643834750"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1778842309729_tv_1.png",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643808068,
          "section_heading": "The Most {Powerful Direct-to-Fan Platform} for Film & Television",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1779266330230_tv_tool_new.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643837168,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643837168,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1778842309729_tv_1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779191597784_tv_m_link_in_bio.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779266330230_tv_tool_new.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643837168,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1779191597784_tv_m_link_in_bio.png",
          "pk": "PAGE#1780643808068",
          "title": "More Powerful Tool",
          "sk": "SECTION#1780643837168"
        }
      ]
    }
  },
  "beauty-fashion": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "sk": "PAGE#1780643717160",
      "background_text_color": "#ffffff",
      "created_at": 1780643717160,
      "status": "PUBLISHED",
      "button_text_color": "#ffffff",
      "background_color": "#000000",
      "title": "Beauty & Fashion",
      "type": "MARKETING_LISTING",
      "url": "beauty-fashion",
      "meta_title": "White-Label Fan Platform for Beauty & Fashion Creators",
      "updated_at": 1780643717160,
      "page_id": 1780643717160,
      "pk": "MARKETINGPAGE",
      "secondary_background_color": "#000000",
      "seoKeywords": "beauty creator platform, fashion creator platform, beauty and fashion monetization, white label beauty platform, fashion fan platform, creator subscription platform, direct-to-fan platform, beauty influencer platform, fashion content monetization, beauty and fashion creator platform",
      "text_color": "#000000",
      "meta_description": "Launch your own branded platform to engage fans, sell subscriptions, and monetize beauty and fashion content with a powerful white-label solution on web and mobile apps.",
      "post_text_color": "#ffffff",
      "gsi1sk": "PAGE#1780643717160",
      "gsi1pk": "beauty-fashion",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1778825876578_beauty_hm.png",
          "subheading": "Create, engage, and monetize your beauty & fashion audience.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "BEAUTY AND MAKEUP HERO PAGE",
          "page_id": 1780643717160,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Turn Beauty & Fashion] \\n Into a Thriving Business.",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643719621,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643719621,
          "post_text_color": "#000000",
          "layout_id": "hero-layout",
          "section_id": 1780643719621,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778825876577_beauty_h_d.png",
          "pk": "PAGE#1780643717160",
          "title": "Beauty and Makeup hero page",
          "sk": "SECTION#1780643719621"
        },
        {
          "subheading": "Experts building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643722027,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643722027,
          "page_id": 1780643717160,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643722027,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643717160",
          "is_visible": false,
          "title": "Featured Creators",
          "sk": "SECTION#1780643722027"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#ffecfe",
          "name": "BUILD YOUR OWN FAN ENGAGEMENT PLATFORM",
          "page_id": 1780643717160,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your {Own Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#002339",
          "cta_text": "See Example",
          "created_at": 1780643724431,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "updated_at": 1780643724431,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643724431,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778732165403_beauty_build_your.png",
          "pk": "PAGE#1780643717160",
          "title": "Build Your Own Fan Engagement Platform",
          "sk": "SECTION#1780643724431"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1778732253065_beauty_fan3.png",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your audience access to your most valued content - including behind the scenes videos, audio and photos, insightful articles, and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643717160,
          "vcss_2_title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1778732253064_beauty_fan1.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643726853,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1778825946666_beauty_fu_back.png",
          "vcss_3_title": "[In-Person Event Ticketing]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1778732253065_beauty_fan2.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643726853,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778732253064_beauty_fan1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your audience access to your most valued content - including behind the scenes videos, audio and photos, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778732253065_beauty_fan2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution of Episodic Videos & Podcasts]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778732253065_beauty_fan3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to games and special events from your own powerful platform. Anti-fraud and scalping technology included.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[In-Person Event Ticketing]"
            }
          ],
          "section_id": 1780643726853,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643717160",
          "title": "Fan Club",
          "sk": "SECTION#1780643726853"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#ffecfe",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1778732300621_beauty_chat_room.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "page_id": 1780643717160,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643729433,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643729433,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778732300621_beauty_chat_room.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643729433,
          "creator_poster_1_description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
          "pk": "PAGE#1780643717160",
          "title": "Chat Room",
          "sk": "SECTION#1780643729433"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1778671199_bt_live_mo.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise during the stream.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "MONETIZE YOUR LIVE STREAMS",
          "page_id": 1780643717160,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643731966,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643731966,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643731966,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1778671199_bt_live_des.gif",
          "pk": "PAGE#1780643717160",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643731966"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences with Calendar Scheduling}",
          "button_text_color": "#ffffff",
          "background_color": "#ffebeb",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1778732382993_beauty_mon2.jpg",
          "page_id": 1780643717160,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780643734381,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779100528272_feedback_bt_1.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778732382993_beauty_mon2.jpg",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778826692459_beauty_h3.jpg",
              "cta_label": "See Example",
              "title": "{Personalized Experiences with Calendar Scheduling}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.Offer one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1778826692459_beauty_h3.jpg",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1779100528272_feedback_bt_1.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780643734381,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643734381,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pk": "PAGE#1780643717160",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643734381"
        },
        {
          "subheading": "Get support from your audience and turn your next product vision into reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780643736786,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1778732462687_beauty_cf_back.png",
          "updated_at": 1780643736786,
          "page_id": 1780643717160,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643736786,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779100613155_feedback_bt_2.png",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643717160",
          "cta_text": "See Example",
          "title": "Crowd funding",
          "sk": "SECTION#1780643736786"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643717160,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1778732624299_gamification_bag.png",
          "created_at": 1780643739181,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643739181,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643739181,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778732624299_prof_gam_back.png",
          "pk": "PAGE#1780643717160",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643739181"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1778732684359_beauty_brand_mob.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643717160,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643741584,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643741584,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643741584,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1778732684359_beauty_brad_des.png",
          "pk": "PAGE#1780643717160",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "sk": "SECTION#1780643741584"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643717160,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1778732740401_beauty_course_down.png",
          "created_at": 1780643743993,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643743993,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643743993,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1778159872272_prof_gam_back.png",
          "pk": "PAGE#1780643717160",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "sk": "SECTION#1780643743993"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1778733003991_beauty_p1.png",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643717160,
          "section_heading": "{Powerful Direct-to-Fan Platform} for Beauty & Fashion",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1778733003991_beauty_pow_t3.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643746424,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643746424,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778733003991_beauty_p1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779100684628_feedback_bt_3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1778733003991_beauty_pow_t3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643746424,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1779100684628_feedback_bt_3.png",
          "pk": "PAGE#1780643717160",
          "title": "More Powerful Tool",
          "sk": "SECTION#1780643746424"
        }
      ]
    }
  },
  "health-wellness-fitness": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "background_text_color": "#ffffff",
      "gsi1pk": "health-wellness-fitness",
      "status": "PUBLISHED",
      "gsi1sk": "PAGE#1780643421235",
      "meta_description": "Top platform for Health, Fitness and Wellness creators to sell subscriptions, livestreams, e-courses, and book 1:1 coaching. White-label platform that let's you the data of your clients.",
      "button_text_color": "#ffffff",
      "background_color": "#000000",
      "type": "MARKETING_LISTING",
      "created_at": 1780643421235,
      "title": "Health, Wellness & Fitness",
      "pk": "MARKETINGPAGE",
      "secondary_background_color": "#000000",
      "meta_title": "Health, Fitness & Fitness Creator Platform",
      "url": "health-wellness-fitness",
      "text_color": "#000000",
      "seoKeywords": "health and wellness, fitness creators, wellness, Direct-to-Fan Platform, subscriptions, premium content, livestreams, e-courses, e-cookbooks, coaching, white-label",
      "page_id": 1780643421235,
      "post_text_color": "#ffffff",
      "updated_at": 1780643421235,
      "sk": "PAGE#1780643421235",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1776858974480_mobile_hw_p.png",
          "subheading": "Cut out the middleman. Build your audience, share your expertise, and earn a sustainable income.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "TURN FITNESS JOURNEY INTO REVENUE STREAM",
          "page_id": 1780643421235,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Your Health & Wellness Expertise.] \\nYour Terms.",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643423930,
          "heading_font_size": "large",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643423930,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643423930,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1776858565962_hw_home_main.png",
          "pk": "PAGE#1780643421235",
          "title": "Turn Fitness Journey into Revenue Stream",
          "sk": "SECTION#1780643423930"
        },
        {
          "subheading": "Experts building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643426345,
          "background_color": "#000000",
          "heading_font_size": "small",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643426345,
          "page_id": 1780643421235,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643426345,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643421235",
          "title": "Featured Creators",
          "sk": "SECTION#1780643426345"
        },
        {
          "subheading": "Launch a website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your health, fitness and food content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#d7edfa",
          "name": "BUILD YOUR OWN CREATOR PLATFORM",
          "page_id": 1780643421235,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your Own {Engagement & Monetization Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#fff0bd",
          "cta_text": "See Example",
          "created_at": 1780643428841,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Global creators trust TopFan for their direct-to-fan monetization and engagement.",
          "seo_content": "TopFan has facilitated over 1000000000 fan engagements for Health & Fitness Creators.\nHealth & Fitness Creators have earned over $100M USD using TopFan's white-label technology.\nHundreds of the biggest Health & Fitness Creators in the world have trusted TopFan for their Direct-to-fan Monetization",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated for creators.",
          "updated_at": 1780643428841,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643428841,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777466363527_heat_build_platform.png",
          "pk": "PAGE#1780643421235",
          "title": "Build Your Own Creator Platform",
          "sk": "SECTION#1780643428841"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Host in real life fitness, wellness, and cooking workshops. Sell tickets with different tiers, VIP access directly inside your own powerful platform.",
          "vcss_2_description": "Offer paid access to your sessions, video series, and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your audience access to your most valued content - including guided sessions, insightful articles,  and personalized experiences.",
          "vcss_4_title": "[Sell tickets directly to your audience]",
          "vcss_4_cta_2_url": "",
          "vcss_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777273382832_fan_club_sub.png",
          "vcss_4_heading_position": "left",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_4_cta_1_url": "",
          "created_at": 1780643431225,
          "background_text_color": "#ffffff",
          "vcss_4_cta_2": "",
          "vcss_4_cta_1": "Learn More",
          "vcss_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1779449533297_links_list__5_.png",
          "updated_at": 1780643431225,
          "layout_id": "vertical-card-snap-scroll-layout",
          "section_id": 1780643431225,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_1_title": "[Subscriptions] for Exclusive Content",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643421235",
          "title": "Fan Club",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777274128266_fan_club_ticketing.png",
          "name": "FAN CLUB",
          "page_id": 1780643421235,
          "vcss_2_title": "Direct Sales & Distribution of [Episodic Videos & Podcasts]",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "vcss_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1776247862752_hv-vertical4.png",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1776089782221_component_49.png",
          "vcss_3_title": "In-Person [Event Ticketing ]",
          "theme_color": "#ffffff",
          "vcss_2_cta_2_url": "",
          "post_text_color": "#ffffff",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777273382832_fan_club_sub.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your audience access to your most valued content - including guided sessions, insightful articles,  and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions] for Exclusive Content"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1779449533297_links_list__5_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your sessions, video series, and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Direct Sales & Distribution of [Episodic Videos & Podcasts]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777274128266_fan_club_ticketing.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Host in real life fitness, wellness, and cooking workshops. Sell tickets with different tiers, VIP access directly inside your own powerful platform.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "In-Person [Event Ticketing ]"
            }
          ],
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_4_description": "Set pricing, create tiers, offer VIP access, and manage \\n bookings. All in one place, with full control over your \\n events.",
          "sk": "SECTION#1780643431225"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#d7edfa",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777464954699_hw_chat_room.webp",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "left",
          "creator_poster_1_title": "[Community] Building Tools",
          "page_id": 1780643421235,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643433671,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643433671,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777464954699_hw_chat_room.webp",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create a safe place for your best audience members to interact with each and share thier own health and wellness journey.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community] Building Tools"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643433671,
          "creator_poster_1_description": "Create a safe place for your best audience members to interact with each and share thier own health and wellness journey.",
          "pk": "PAGE#1780643421235",
          "title": "Chat Room",
          "sk": "SECTION#1780643433671"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1777874257_f_mob_hw.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise during the stream.",
          "button_text_color": "#000000",
          "created_at": 1780643436113,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643436113,
          "page_id": 1780643421235,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643436113,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1777873891_f_des_hw.gif",
          "pk": "PAGE#1780643421235",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643436113"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences with Calendar Scheduling}",
          "button_text_color": "#ffffff",
          "background_color": "#ffebff",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777548623340_feeback_5.png",
          "page_id": 1780643421235,
          "pinned_horizontal_3_subtitle": "Sell one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_title": "{Sell Products} Under Your Own Brand",
          "pinned_horizontal_1_subtitle": "Offer exclusive merchandise to audience via your embedded e-commerce store that seamlessly integrates with Shopify.",
          "created_at": 1780643438699,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777274486684_monetization_shopify.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Under Your Own Brand",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer exclusive merchandise to audience via your embedded e-commerce store that seamlessly integrates with Shopify."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777548623340_feeback_5.png",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and send targeted emails, SMS, DMs, and Push Notifications from you own platform."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777548091305_feedback_3.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences with Calendar Scheduling}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Sell one-on-one private video coaching calls, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777548091305_feedback_3.png",
          "pinned_horizontal_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777274486684_monetization_shopify.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780643438699,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643438699,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pk": "PAGE#1780643421235",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and send targeted emails, SMS, DMs, and Push Notifications from you own platform.",
          "title": "Monetizations",
          "sk": "SECTION#1780643438699"
        },
        {
          "subheading": "Fund your new health, wellness and fitness projects directly through your fan community.",
          "button_text_color": "#ffffff",
          "created_at": 1780643441573,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1776083837198_back-f2.png",
          "updated_at": 1780643441573,
          "page_id": 1780643421235,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643441573,
          "content_image": "https://cdn-www7.topfans.dev/TopFans/Home1779449619536_group_75932__1_.png",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Help Fund} our New Cookbook",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643421235",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643441573"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your most loyal supporters with points, badges, and leaderboard rankings that unlock exclusive perks, content and discounts.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643421235,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1777275423183_gamification_bag.png",
          "created_at": 1780643444031,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643444031,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643444031,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1775826746129_b_p_background.png",
          "pk": "PAGE#1780643421235",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643444031"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1777275925927_hw_ads_mobile.png",
          "subheading": "Earn money from 3rd party brands and earn revenue through ads or special offers for your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643421235,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643446581,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643446581,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643446581,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777275925927_hw_ads_des.png",
          "pk": "PAGE#1780643421235",
          "title": "Brand Sponsorship Advertising & VIP Discount Offers",
          "sk": "SECTION#1780643446581"
        },
        {
          "subheading": "Package your health, wellness and food expertise into premium e-courses and downloadble e-books to generate new income.",
          "button_text_color": "#000000",
          "background_color": "#010101",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643421235,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1777988882259_fee_hw_s.png",
          "created_at": 1780643448969,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643448969,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643448969,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777277665636_mon_ecourse_bac.png",
          "pk": "PAGE#1780643421235",
          "title": "Monetize Your Expertise eCourses & Downloadables",
          "sk": "SECTION#1780643448969"
        },
        {
          "creator_poster_4_title": "[Community Chat Rooms]",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1776084159286_go_globa.png",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_title": "Reach a [Global Audience]",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643451561,
          "background_text_color": "#000000",
          "creator_poster_2_cta_2": "",
          "updated_at": 1780643451561,
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776084159286_go_globa.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with local pricing (cost-of-living) optimization.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Reach a [Global Audience]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777976815548_f_hw_lib.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with an embeddable Link in Bio that has all your courses, livestreams, event tickets, merch, and content.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777281065032_newsletter_seanna.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Build a database and proactively send your audience free or locked newsletter content by email.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Send Beautiful Branded [Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643451561,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777976815548_f_hw_lib.png",
          "pk": "PAGE#1780643421235",
          "title": "More Powerful Tool",
          "subheading": "TopFan eliminates the need for tens of expensive creator tools, bringing everything together in one place for a seamless experience.",
          "creator_poster_4_cta_2_url": "",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "name": "MORE POWERFUL TOOL",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_heading_position": "right",
          "page_id": 1780643421235,
          "section_heading": "The Most {Powerful Direct-To-Fan Platform} for Health, Fitness and Food Creators",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_4_cta_1": "See Example",
          "creator_poster_4_cta_2": "",
          "creator_poster_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777281065032_newsletter_seanna.png",
          "creator_poster_2_heading_position": "left",
          "heading_font_size": "medium",
          "creator_poster_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1777280635159_chatroom_hw.png",
          "creator_poster_3_title": "Send Beautiful Branded [Newsletters]",
          "theme_color": "#ffffff",
          "creator_poster_3_cta_2_url": "",
          "post_text_color": "#ffffff",
          "creator_poster_4_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with local pricing (cost-of-living) optimization.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with an embeddable Link in Bio that has all your courses, livestreams, event tickets, merch, and content.",
          "creator_poster_3_description": "Build a database and proactively send your audience free or locked newsletter content by email.",
          "creator_poster_4_heading_position": "left",
          "creator_poster_4_description": "Create a safe place for your best fans to interact with each other by uploading their photos and videos from your tours.",
          "sk": "SECTION#1780643451561"
        },
        {
          "button_text_color": "#000000",
          "testimonial_3_name": "Dice",
          "background_color": "#ffebff",
          "testimonial_1_background_image": null,
          "testimonial_4_creator_type": "Fitness & Wellness",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_syd.webp",
          "testimonial_2_user_name": "siennabrooks",
          "testimonial_4_stars": "5",
          "testimonial_3_user_name": "dice",
          "testimonial_3_content": "What I love most is how approachable everything feels. The wellness tips are easy to understand and actually work in real life. I’ve noticed improvements in my sleep, stress levels, and overall energy. It’s not just information—it’s a complete lifestyle shift that feels sustainable.",
          "page_id": 1780643421235,
          "testimonial_2_content": "I’ve tried many wellness platforms, but this one stands out. The guidance on nutrition, fitness, and mental health feels balanced and realistic. It doesn’t push extremes, which I appreciate. I feel more energized, focused, and in control of my lifestyle since I started following the advice shared here.",
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} creators have trusted us since we started.",
          "testimonial_2_background_image": null,
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_jerry.webp",
          "testimonial_1_content": "This platform has truly improved my approach to health and wellness. The tips are simple, practical, and easy to follow in daily life. I’ve been able to build better habits without feeling overwhelmed. It’s helped me stay consistent with both my physical fitness and mental well-being in a natural way.",
          "secondary_background_color": "#000000",
          "testimonial_2_name": "Balance With Sienna",
          "testimonial_2_stars": "5",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_jerry.webp",
              "creator_type": "Fitness & Wellness",
              "user_name": "jerryperry",
              "name": "Jerry Perry",
              "stars": "5",
              "content": "This platform has truly improved my approach to health and wellness. The tips are simple, practical, and easy to follow in daily life. I’ve been able to build better habits without feeling overwhelmed. It’s helped me stay consistent with both my physical fitness and mental well-being in a natural way."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_balance.jpg",
              "creator_type": "Fitness & Wellness",
              "user_name": "siennabrooks",
              "name": "Balance With Sienna",
              "stars": "5",
              "content": "I’ve tried many wellness platforms, but this one stands out. The guidance on nutrition, fitness, and mental health feels balanced and realistic. It doesn’t push extremes, which I appreciate. I feel more energized, focused, and in control of my lifestyle since I started following the advice shared here."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_dice.webp",
              "creator_type": "Fitness & Wellness",
              "user_name": "dice",
              "name": "Dice",
              "stars": "5",
              "content": "What I love most is how approachable everything feels. The wellness tips are easy to understand and actually work in real life. I’ve noticed improvements in my sleep, stress levels, and overall energy. It’s not just information—it’s a complete lifestyle shift that feels sustainable."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_syd.webp",
              "creator_type": "Fitness & Wellness",
              "user_name": "fitsid",
              "name": "Sweating with Syd",
              "stars": "5",
              "content": "Since I started following this wellness platform, I’ve felt more balanced and motivated. The focus on both mental and physical health is exactly what I needed. It’s encouraging without being overwhelming, and it helps me stay on track with my goals every day."
            }
          ],
          "testimonial_title": "Testimonials",
          "created_at": 1780643459435,
          "testimonial_4_background_image": null,
          "brand_images": [],
          "testimonial_3_stars": "5",
          "testimonial_1_user_name": "jerryperry",
          "background_text_color": "#000000",
          "testimonial_1_name": "Jerry Perry",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_dice.webp",
          "testimonial_4_content": "Since I started following this wellness platform, I’ve felt more balanced and motivated. The focus on both mental and physical health is exactly what I needed. It’s encouraging without being overwhelming, and it helps me stay on track with my goals every day.",
          "theme_color": "#000000",
          "updated_at": 1780643459435,
          "post_text_color": "#ffffff",
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1775828840164_balance.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1780643459435,
          "testimonial_4_user_name": "fitsid",
          "testimonial_1_stars": "5",
          "testimonial_2_creator_type": "Fitness & Wellness",
          "testimonial_4_name": "Sweating with Syd",
          "testimonial_1_creator_type": "Fitness & Wellness",
          "testimonial_3_creator_type": "Fitness & Wellness",
          "pk": "PAGE#1780643421235",
          "is_visible": false,
          "title": "Testimonials",
          "sk": "SECTION#1780643459435"
        }
      ]
    }
  },
  "food-nutrition": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "gsi1pk": "food-nutrition",
      "sequence_number": 2,
      "updated_at": 1781597711149,
      "meta_title": "White-Label Fan Platform for Food & Nutrition Creators",
      "background_color": "#000000",
      "seoKeywords": "food creators, nutrition creators, chefs, nutritionists, dietitians, healthy eating, wellness creators, recipe creators, cooking content, meal planning, nutrition coaching, food influencers, healthy lifestyle, recipe platform, cooking community, food education, nutrition education",
      "pk": "MARKETINGPAGE",
      "created_at": 1780643988690,
      "status": "PUBLISHED",
      "post_text_color": "#ffffff",
      "gsi1sk": "PAGE#1780643988690",
      "url": "food-nutrition",
      "title": "Food & Nutrition",
      "background_text_color": "#ffffff",
      "secondary_background_color": "#000000",
      "type": "MARKETING_LISTING",
      "text_color": "#000000",
      "sk": "PAGE#1780643988690",
      "page_id": 1780643988690,
      "meta_description": "The #1 Direct-to-Fan Platform for Food & Nutrition Creators. Share recipes, nutrition programs, premium content, memberships, courses, livestreams and merchandise directly with your audience while owning your community and data.",
      "button_text_color": "#ffffff",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779791756559_ff_h_m.png",
          "subheading": "Turn Your Passion for Food Into a Thriving Community",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "HERO PAGE",
          "page_id": 1780643988690,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Inspire Through Food.] Transform Everyday Wellness",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "Get Started",
          "created_at": 1780643991168,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643991168,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643991168,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779791756559_ff_f_d.png",
          "pk": "PAGE#1780643988690",
          "title": "Hero Page",
          "sk": "SECTION#1780643991168"
        },
        {
          "subheading": "Experts building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643993611,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURE CREATOR",
          "updated_at": 1780643993611,
          "page_id": 1780643988690,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643993611,
          "section_heading": "[Featured Creator]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643988690",
          "is_visible": false,
          "title": "Feature Creator",
          "sk": "SECTION#1780643993611"
        },
        {
          "subheading": "Launch a website under your own domain and branded iOS and Android apps. Personalize your look, distribute your food and nutrition content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#ffecfe",
          "name": "BUILD YOUR OWN FAN ENGAGEMENT PLATFORM",
          "page_id": 1780643988690,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your {Own Engagement & Monetization Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#ababff",
          "cta_text": "Learn More",
          "created_at": 1780643996143,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Global creators trust TopFan for their direct-to-fan monetization and engagement.",
          "seo_content": "TopFan has facilitated over 1000000000 fan engagements for Health & Fitness Creators.\nHealth & Fitness Creators have earned over $100M USD using TopFan's white-label technology.\nHundreds of the biggest Food & Nutrition Creators in the world have trusted TopFan for their Direct-to-fan Monetization.",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated for creators.",
          "updated_at": 1780643996143,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643996143,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779444472962_group_75967.png",
          "pk": "PAGE#1780643988690",
          "title": "Build Your Own Fan Engagement Platform",
          "sk": "SECTION#1780643996143"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#ffffff",
          "vcss_3_description": "Host in real life cooking and nutrition workshops. Sell tickets with different tiers, VIP access directly inside your own powerful platform.",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1779791890962_ff_f3.png",
          "vcss_2_description": "Offer paid access to your sessions, video series, and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your audience access to your most valued content - including guided sessions, insightful articles,  and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643988690,
          "vcss_2_title": "Direct Sales & Distribution of [Episodic Videos & Podcasts]",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1779446146287_frame_2147225940__3_.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643998589,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1779446146287_image_1660__2_.png",
          "vcss_3_title": "In-Person [Event Ticketing ]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1779446235023_links_list__3_.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643998589,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779446146287_frame_2147225940__3_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your audience access to your most valued content - including guided sessions, insightful articles,  and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions] for Exclusive Content"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779446235023_links_list__3_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your sessions, video series, and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Direct Sales & Distribution of [Episodic Videos & Podcasts]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779791890962_ff_f3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Host in real life cooking and nutrition workshops. Sell tickets with different tiers, VIP access directly inside your own powerful platform.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "In-Person [Event Ticketing ]"
            }
          ],
          "section_id": 1780643998589,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions] for Exclusive Content",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643988690",
          "title": "Fan Club",
          "sk": "SECTION#1780643998589"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#d7edfa",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779446497914_link_in_bio_music_vertical__2_.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_title": "[Community] Building Tools",
          "page_id": 1780643988690,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780644000999,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780644000999,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779446497914_link_in_bio_music_vertical__2_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe place for your best audience members to interact with each and share thier own recipes and healthy living inspiration.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community] Building Tools"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780644000999,
          "creator_poster_1_description": "Create a safe place for your best audience members to interact with each and share thier own recipes and healthy living inspiration.",
          "pk": "PAGE#1780643988690",
          "title": "Chat Room",
          "sk": "SECTION#1780644000999"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/gif/1779447546358_live_streams__17_.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise during the stream.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "LIVESTREAM",
          "page_id": 1780643988690,
          "cta_link": "https://www.balancewithsienna.com/siennabrooks",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780644003382,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780644003382,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780644003382,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/gif/1779447546358_desktop_live_stream__25_.gif",
          "pk": "PAGE#1780643988690",
          "title": "Livestream",
          "sk": "SECTION#1780644003382"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences} with Calendar Scheduling",
          "button_text_color": "#ffffff",
          "background_color": "#ffebeb",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONITIZATION",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1779792001034_ff_m2.png",
          "page_id": 1780643988690,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/siennabrooks",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780644005835,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779446914028_links_list__4_.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779792001034_ff_m2.png",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/siennabrooks",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779792001034_ff_m3.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences} with Calendar Scheduling",
              "cta_redirection_url": "https://www.balancewithsienna.com/siennabrooks",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1779792001034_ff_m3.png",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1779446914028_links_list__4_.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780644005835,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780644005835,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/siennabrooks",
          "pk": "PAGE#1780643988690",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monitization",
          "sk": "SECTION#1780644005835"
        },
        {
          "subheading": "Mobilize your supporters and turn your next initiative or community project into reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780644008263,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1779447173939_content_section__6_.png",
          "updated_at": 1780644008263,
          "page_id": 1780643988690,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780644008263,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779447173939_frame_2147226130__1_.png",
          "cta_link": "https://www.balancewithsienna.com/siennabrooks",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643988690",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780644008263"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643988690,
          "cta_link": "",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1779447346234_home1777638819069_gamification_bag.webp",
          "created_at": 1780644010702,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780644010702,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780644010702,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779447346234_home1777638819068_prof_gam_back.webp",
          "pk": "PAGE#1780643988690",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780644010702"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779792334041_ff_b_d.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643988690,
          "cta_link": "https://www.balancewithsienna.com/siennabrooks",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780644013156,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780644013156,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780644013156,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779792334040_ff_b_m.png",
          "pk": "PAGE#1780643988690",
          "title": "Brand Sponsorship Advertising & VIP Discount Offers",
          "sk": "SECTION#1780644013156"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE WITH ECOURSES & DOWNLOADABLES",
          "page_id": 1780643988690,
          "cta_link": "https://www.balancewithsienna.com/siennabrooks",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1779447733259_frame_2147226169__1_.png",
          "created_at": 1780644015592,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780644015592,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780644015592,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779447733259_home1777638819068_prof_gam_back.webp",
          "pk": "PAGE#1780643988690",
          "title": "Monetize Your Expertise with eCourses & Downloadables",
          "sk": "SECTION#1780644015592"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/siennabrooks",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779448143537_link_in_bio_health_vertical__4_.png",
          "name": "MORE POWERFUL TOOLS",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/siennabrooks",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643988690,
          "section_heading": "The Most Powerful {Direct-to-Fan} Platform for Chefs & Food Influencers",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1779448278610_chatgpt_image_may_22__2026__03_34_26_pm_1.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780644018000,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780644018000,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779448143537_link_in_bio_health_vertical__4_.png",
              "cta_1_url": "https://www.balancewithsienna.com/siennabrooks",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779448278610_chatgpt_image_may_22__2026__03_37_40_pm_1.png",
              "cta_1_url": "https://www.balancewithsienna.com/siennabrooks",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779448278610_chatgpt_image_may_22__2026__03_34_26_pm_1.png",
              "cta_1_url": "https://www.balancewithsienna.com/siennabrooks",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780644018000,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/siennabrooks",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1779448278610_chatgpt_image_may_22__2026__03_37_40_pm_1.png",
          "pk": "PAGE#1780643988690",
          "title": "More Powerful Tools",
          "sk": "SECTION#1780644018000"
        }
      ]
    }
  },
  "athletes": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "pk": "MARKETINGPAGE",
      "url": "athletes",
      "background_color": "#000000",
      "post_text_color": "#ffffff",
      "page_id": 1780643480164,
      "updated_at": 1780643480164,
      "gsi1sk": "PAGE#1780643480164",
      "gsi1pk": "athletes",
      "background_text_color": "#ffffff",
      "status": "PUBLISHED",
      "meta_title": "Direct-to-Fan Platform for Athletes & Sports Creators",
      "sk": "PAGE#1780643480164",
      "meta_description": "The #1 Direct-to-Fan Platform for Athletes and Sports Creators.  Sell merchandise, content, merchandise directly to fans and own the fan data.",
      "button_text_color": "#ffffff",
      "seoKeywords": "athletes, top athletes, sports creators, athlete content, follow athletes, athlete platform, connect with athletes",
      "text_color": "#000000",
      "type": "MARKETING_LISTING",
      "created_at": 1780643480164,
      "secondary_background_color": "#000000",
      "title": "Athletes",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1777876457511_f_ath_hero_mob.png",
          "subheading": "Build your Legacy Beyond the Jersey.  The \\nFuture of the Pro is Personal.",
          "button_text_color": "#000000",
          "created_at": 1780643482685,
          "background_color": "#000000",
          "heading_font_size": "large",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643482685,
          "page_id": 1780643480164,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643482685,
          "cta_link": "",
          "section_heading": "{Own the Game.\\n Own the Data.}",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777876700977_f_ath_hero__1_.png",
          "pk": "PAGE#1780643480164",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Turn your Athletic Into Revenue Stream",
          "sk": "SECTION#1780643482685"
        },
        {
          "subheading": "Athletes building their audience and income on their own terms.",
          "button_text_color": "#ffffff",
          "created_at": 1780643485593,
          "background_color": "#000000",
          "heading_font_size": "small",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURED CREATORS",
          "updated_at": 1780643485593,
          "page_id": 1780643480164,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643485593,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643480164",
          "title": "Featured Creators",
          "sk": "SECTION#1780643485593"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content, sell merchandise, create community, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#fefde7",
          "name": "BUILD YOUR OWN CREATOR PLATFORM",
          "page_id": 1780643480164,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.ajwhite.fans/",
          "section_heading": "Build Your {Own Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#ffa36a",
          "cta_text": "See Example",
          "created_at": 1780643488020,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Global creators trust TopFan for their direct-to-fan monetization and engagement.",
          "seo_content": "TopFan has facilitated over 1000000000 fan engagements for Athletes.\nAthletes have earned over $100M USD using TopFan's white-label technology.\nHundreds of the biggest Athletes in the world have trusted TopFan for their Direct-to-fan Monetization",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated for creators.",
          "updated_at": 1780643488020,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643488020,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777466610451_ath_build_your.png",
          "pk": "PAGE#1780643480164",
          "title": "Build Your Own Creator Platform",
          "sk": "SECTION#1780643488020"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "List your event or competition schedule, with ability to sell tickets, VIP Meet & Greets and unique pre-sale codes.",
          "vcss_3_cta_1_url": "https://www.ajwhite.fans/",
          "vcss_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777283383218_ath_ticket.png",
          "vcss_2_description": "Sell and distribute your complete catalog of episodic videos, podcasts or stream via DSPs.",
          "vcss_1_description": "Create subscription plans that allow your fans to access exclusive content, merchandise drops, livestreams, giveaways and more.",
          "name": "FAN CLUB",
          "page_id": 1780643480164,
          "vcss_2_title": "{Direct Sales & Distribution} of Videos and Podcasts",
          "vcss_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777288832815_ath_fan_s.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.ajwhite.fans/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643490462,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777288877161_ath_fan_back.png",
          "vcss_3_title": "[Event Schedules ]\\n with VIP Meet & Greet Ticketing",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777283383218_ath_po.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643490462,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777288832815_ath_fan_s.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create subscription plans that allow your fans to access exclusive content, merchandise drops, livestreams, giveaways and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions] \\nfor Exclusive Content & Access"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777283383218_ath_po.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell and distribute your complete catalog of episodic videos, podcasts or stream via DSPs.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "{Direct Sales & Distribution} of Videos and Podcasts"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777283383218_ath_ticket.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "List your event or competition schedule, with ability to sell tickets, VIP Meet & Greets and unique pre-sale codes.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Event Schedules ]\\n with VIP Meet & Greet Ticketing"
            }
          ],
          "section_id": 1780643490462,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.ajwhite.fans/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions] \\nfor Exclusive Content & Access",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643480164",
          "title": "Fan Club",
          "sk": "SECTION#1780643490462"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#fefde7",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.ajwhite.fans/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777884281146_f_ath_chat_room.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "left",
          "creator_poster_1_title": "Interactive [Community] Tools",
          "page_id": 1780643480164,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643492977,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "updated_at": 1780643492977,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777884281146_f_ath_chat_room.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create a safe place for your best fans to interact with each other by uploading their photos and videos, and sharing news and commentary.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Interactive [Community] Tools"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643492977,
          "creator_poster_1_description": "Create a safe place for your best fans to interact with each other by uploading their photos and videos, and sharing news and commentary.",
          "pk": "PAGE#1780643480164",
          "title": "Chat Room",
          "sk": "SECTION#1780643492977"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1777874411_f_mob_ath.gif",
          "subheading": "Host live classes, workshops, or conversations and charge fans for access - directly from your own creator platform.",
          "button_text_color": "#000000",
          "created_at": 1780643496435,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643496435,
          "page_id": 1780643480164,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643496435,
          "cta_link": "https://www.ajwhite.fans/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "cta_text_2": "",
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1777874335_f_des_ath.gif",
          "pk": "PAGE#1780643480164",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Monetize Your Live Streams",
          "sk": "SECTION#1780643496435"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences}",
          "button_text_color": "#ffffff",
          "background_color": "#ffebff",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZTION",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777284120578_ath_fc_rel.png",
          "page_id": 1780643480164,
          "pinned_horizontal_3_subtitle": "Fans can book 1-on-1 video calls, shoot-outs or other fan experiences that you create.  Includes Google and Microsoft Calendar Integration so you never get double booked.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.ajwhite.fans/",
          "pinned_horizontal_1_title": "{Sell Products} Directly Within your Website and App",
          "pinned_horizontal_1_subtitle": "Offer exclusive merchandise to fan club members with special discounts.  Full integration with Shopify.",
          "created_at": 1780643498918,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777285622005_ath_shop_merch.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly Within your Website and App",
              "cta_redirection_url": "https://www.ajwhite.fans/",
              "subtitle": "Offer exclusive merchandise to fan club members with special discounts.  Full integration with Shopify."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777284120578_ath_fc_rel.png",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.ajwhite.fans/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your fans.  Build segments and send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777284120578_ath_fc_ec.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences}",
              "cta_redirection_url": "https://www.ajwhite.fans/",
              "subtitle": "Fans can book 1-on-1 video calls, shoot-outs or other fan experiences that you create.  Includes Google and Microsoft Calendar Integration so you never get double booked."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1777284120578_ath_fc_ec.png",
          "pinned_horizontal_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1777285622005_ath_shop_merch.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.ajwhite.fans/",
          "updated_at": 1780643498918,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643498918,
          "pinned_horizontal_2_cta_redirection_url": "https://www.ajwhite.fans/",
          "pk": "PAGE#1780643480164",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your fans.  Build segments and send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetiztion",
          "sk": "SECTION#1780643498918"
        },
        {
          "subheading": "Fund your next athletic endeavor or challenge directly through your fan community.",
          "button_text_color": "#ffffff",
          "created_at": 1780643501432,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1776433932932_content_section__2_.png",
          "updated_at": 1780643501432,
          "page_id": 1780643480164,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643501432,
          "content_image": "https://cdn-www7.topfans.dev/TopFans/Home1777877006694_f_ath_c_f.png",
          "cta_link": "https://www.ajwhite.fans/",
          "section_heading": "{Crowdfund} Your Projects & Goals",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643480164",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Projects",
          "sk": "SECTION#1780643501432"
        },
        {
          "subheading": "Turn fan engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1777284293626_gamification_bag.png",
          "button_text_color": "#000000",
          "created_at": 1780643504004,
          "background_color": "#eaf0e2",
          "heading_font_size": "medium",
          "include_highlighted_border": "false",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643504004,
          "page_id": 1780643480164,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643504004,
          "cta_link": "https://www.ajwhite.fans/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1776429944297_home1775826746129_b_p_background.webp",
          "pk": "PAGE#1780643480164",
          "heading_position": "left",
          "cta_text": "See Example",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643504004"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/TopFans/Home1777289407774_ath_ads_mob.png",
          "subheading": "Earn money from brands and earn through ads or special offers for your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643480164,
          "cta_link": "https://www.ajwhite.fans/",
          "section_heading": "{Brand Sponsorship\\n Advertising & VIP\\n Discount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643506465,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643506465,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643506465,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1777289407774_ath_ads_de.png",
          "pk": "PAGE#1780643480164",
          "title": "Brand Sponsorship Advertising & VIP Discount Offers",
          "sk": "SECTION#1780643506465"
        },
        {
          "subheading": "Package your athletic expertise into premium e-courses,  downloadable guides and e-books, and generate new income.",
          "button_text_color": "#000000",
          "background_color": "#010101",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643480164,
          "cta_link": "https://www.ajwhite.fans/",
          "section_heading": "Monetize Your Expertise with {eCourses & Downloadables}",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www7.topfans.dev/TopFans/Home1777972692994_fe_ath_d.png",
          "created_at": 1780643508895,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643508895,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643508895,
          "hero_image": "https://cdn-www7.topfans.dev/TopFans/Home1776430362849_frame_2147226189.png",
          "pk": "PAGE#1780643480164",
          "title": "Monetize Your Expertise eCourses & Downloadables",
          "sk": "SECTION#1780643508895"
        },
        {
          "creator_poster_4_title": "[Community Chat Rooms]",
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1776431142321_go_global_health.png",
          "creator_poster_3_cta_1_url": "https://www.ajwhite.fans/",
          "creator_poster_1_title": "Go [Global]",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643511433,
          "background_text_color": "#000000",
          "creator_poster_2_cta_2": "",
          "updated_at": 1780643511433,
          "creator_poster_cards": [
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776431142321_go_global_health.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with local pricing (cost-of-living) optimization.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1777976891421_f_ath_lib.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with an embeddable Link in Bio that has all your music, tickets, merch, and content in one place.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1776431142322_newsletters_health.png",
              "cta_1_url": "https://www.ajwhite.fans/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Fans can signup for your email newsletter on your site and receive you latest news, ticketing and merchandise information. There is no cost to send newsletters.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643511433,
          "creator_poster_2_cta_1_url": "https://www.ajwhite.fans/",
          "creator_poster_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1777976891421_f_ath_lib.png",
          "pk": "PAGE#1780643480164",
          "title": "More Powerful Tools",
          "subheading": "TopFan eliminates the need for tens of expensive creator tools, bringing everything together in one place for a seamless fan experience.",
          "creator_poster_4_cta_2_url": "",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.ajwhite.fans/",
          "name": "MORE POWERFUL TOOLS",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_heading_position": "right",
          "page_id": 1780643480164,
          "section_heading": "The Most Powerful {Direct-To-Fan Platform} for Athletes",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_4_cta_1": "See Example",
          "creator_poster_4_cta_2": "",
          "creator_poster_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1776431142322_newsletters_health.png",
          "creator_poster_2_heading_position": "left",
          "heading_font_size": "medium",
          "creator_poster_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1777284900354_ath_chat_room.png",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "theme_color": "#ffffff",
          "creator_poster_3_cta_2_url": "",
          "post_text_color": "#ffffff",
          "creator_poster_4_cta_1_url": "https://www.ajwhite.fans/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with local pricing (cost-of-living) optimization.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with an embeddable Link in Bio that has all your music, tickets, merch, and content in one place.",
          "creator_poster_3_description": "Fans can signup for your email newsletter on your site and receive you latest news, ticketing and merchandise information. There is no cost to send newsletters.",
          "creator_poster_4_heading_position": "left",
          "creator_poster_4_description": "Create a safe place for your best fans to interact with each other by uploading their photos and videos from your tours.",
          "sk": "SECTION#1780643511433"
        }
      ]
    }
  },
  "membership-organizations": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "post_text_color": "#ffffff",
      "text_color": "#000000",
      "meta_description": "membership Organizations platform, membership community platform, member engagement platform, white label membership platform, community membership software, membership subscription platform, member community management, direct-to-member platform, membership monetization platform, professional membership platform",
      "gsi1sk": "PAGE#1780644034915",
      "type": "MARKETING_LISTING",
      "secondary_background_color": "#000000",
      "pk": "MARKETINGPAGE",
      "updated_at": 1781597711149,
      "created_at": 1780644034915,
      "gsi1pk": "membership-organizations",
      "button_text_color": "#ffffff",
      "seoKeywords": "Build a branded membership platform to engage members, share exclusive content, manage communities, and grow recurring revenue.",
      "title": "Membership Organization",
      "meta_title": "White-Label Platform for Membership Organizations",
      "status": "PUBLISHED",
      "page_id": 1780644034915,
      "background_text_color": "#ffffff",
      "background_color": "#000000",
      "url": "membership-organizations",
      "sk": "PAGE#1780644034915",
      "sequence_number": 3,
      "sections": [
        {
          "background_color": "#000000",
          "background_image": null,
          "background_text_color": "#ffffff",
          "button_text_color": "#000000",
          "created_at": 1780644037312,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_link_2": "",
          "cta_text": "See Example",
          "cta_text_2": "",
          "heading_font_size": "large",
          "heading_position": "left",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779802419600_mo_hero__1_.jpg",
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779802352292_mo_hero_m.jpg",
          "layout_id": "hero-layout",
          "name": "HERO PAGE",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "[Connect Communities. Create Value 1.]",
          "section_id": 1780644037312,
          "sequence_number": 1,
          "subheading": "Engage members, share exclusive content, and grow your community—all in one place.",
          "theme_color": "#ffffff",
          "title": "Hero Page",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644037312"
        },
        {
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "button_text_color": "#ffffff",
          "created_at": 1780644039878,
          "is_visible": false,
          "layout_id": "feature-creator-layout",
          "name": "FEATURED CREATORS",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#232323",
          "section_heading": "[Featured Creators]",
          "section_id": 1780644039878,
          "sequence_number": 2,
          "subheading": "Experts building their audience and income on their own terms.",
          "theme_color": "#ffffff",
          "title": "Featured Creators",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644039878"
        },
        {
          "background_color": "#ffecfe",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1780999785475_wp12844884.jpg",
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "created_at": 1780644042251,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_text": "See Example",
          "heading_font_size": "medium",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779801121733_mo_b.png",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "highlighted_info_position": "left",
          "layout_id": "image-bottom-layout",
          "name": "BUILD YOUR OWN FAN ENGAGEMENT PLATFORM",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#ababff",
          "section_heading": "Build Your Own {Member Engagement Platform}",
          "section_id": 1780644042251,
          "seo_content": "",
          "sequence_number": 3,
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your look, distribute your digital content,  create community, generated revenues, and own the data.",
          "theme_color": "#000000",
          "title": "Build Your Own Fan Engagement Platform",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644042251"
        },
        {
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "button_text_color": "#000000",
          "created_at": 1780644044684,
          "layout_id": "vertical-card-snap-scroll-layout",
          "name": "FAN CLUB",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_id": 1780644044684,
          "sequence_number": 4,
          "theme_color": "#ffffff",
          "title": "Fan Club",
          "updated_at": 1781596932216,
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_cta_2": "",
          "vcss_1_cta_2_url": "",
          "vcss_1_description": "Create membership plans and give your members access to your most valued content - including videos, podcasts, photo galleries, insightful articles, and personalized experiences.",
          "vcss_1_heading_position": "left",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1779963811548_m_o_ff1.png",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_2_cta_1": "See Example",
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_2_cta_2": "",
          "vcss_2_cta_2_url": "",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every viewer.",
          "vcss_2_heading_position": "left",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1779880225225_org_f2.png",
          "vcss_2_title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts",
          "vcss_3_cta_1": "See Example",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_cta_2": "",
          "vcss_3_cta_2_url": "",
          "vcss_3_description": "Sell tickets to online and in-person events from your own powerful platform.",
          "vcss_3_heading_position": "left",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1779801212386_mo_f3.png",
          "vcss_3_title": "In-Person [Event Ticketing]",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1779363790145_gs_back.png",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779963811548_m_o_ff1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your members access to your most valued content - including videos, podcasts, photo galleries, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779880225225_org_f2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779801212386_mo_f3.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to online and in-person events from your own powerful platform.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "In-Person [Event Ticketing]"
            }
          ],
          "sk": "SECTION#1780644044684"
        },
        {
          "background_color": "#fffbf2",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1781000421340_wp9152334.jpg",
          "background_text_color": "#000000",
          "button_text_color": "#000000",
          "created_at": 1780644047057,
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_1_description": "Create a safe space for your members to interact with each other via chat rooms and direct messaging.",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779880339934_org_cha.png",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779880339934_org_cha.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe space for your members to interact with each other via chat rooms and direct messaging.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "heading_font_size": "medium",
          "include_highlighted_border": "false",
          "layout_id": "creator-poster-layout",
          "name": "CHAT ROOM",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "",
          "section_id": 1780644047057,
          "sequence_number": 5,
          "subheading": "",
          "theme_color": "#ffffff",
          "title": "Chat Room",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644047057"
        },
        {
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "button_text_color": "#000000",
          "created_at": 1780644049441,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_link_2": "",
          "cta_text": "See Example",
          "cta_text_2": "",
          "heading_font_size": "medium",
          "heading_position": "left",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1779792978_mo_d_live.gif",
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1779792977_or_d_live.gif",
          "layout_id": "hero-layout",
          "name": "LIVE STREAM",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "section_id": 1780644049441,
          "sequence_number": 6,
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise and tickets during the stream.",
          "theme_color": "#ffffff",
          "title": "Live Stream",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644049441"
        },
        {
          "background_color": "#ffebeb",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1781002570650_background_flare__1_.jpg",
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "created_at": 1780644051805,
          "heading_font_size": "medium",
          "layout_id": "pinned-horizontal-scroll-layout",
          "name": "MONETIZATIONS",
          "page_id": 1780644034915,
          "pinned_horizontal_1_cta_label": "See Example",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1779880728344_org_m1.png",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1779799984350_mo_m_2.jpg",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1779880728344_org_m3.png",
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls and in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "pinned_horizontal_3_title": "{Personalized Experiences} with Calendar Scheduling",
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779880728344_org_m1.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779799984350_mo_m_2.jpg",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779880728344_org_m3.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences} with Calendar Scheduling",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer one-on-one private video coaching calls and in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#ffffff",
          "section_heading": "",
          "section_id": 1780644051805,
          "sequence_number": 7,
          "subheading": "",
          "theme_color": "#000000",
          "title": "Monetizations",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644051805"
        },
        {
          "background_color": "#000000",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1779370461624_gs_back.webp",
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779880857287_org_cf.png",
          "created_at": 1780644054171,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_text": "See Example",
          "heading_font_size": "medium",
          "layout_id": "image-upper-layout",
          "name": "CROWD FUNDING OF NEW PROJECTS",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "{Crowd Funding} of New Projects",
          "section_id": 1780644054171,
          "sequence_number": 8,
          "subheading": "Raise money directly from your membership for critical projects.",
          "theme_color": "#000000",
          "title": "Crowd Funding of New Projects",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644054171"
        },
        {
          "background_color": "#eaf0e2",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1781000726873_photo-1723524385625-556cd557c7de.jpg",
          "background_text_color": "#ffffff",
          "button_text_color": "#000000",
          "created_at": 1780644056534,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_text": "See Example",
          "heading_font_size": "medium",
          "heading_position": "left",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777638819068_prof_gam_back.png",
          "include_highlighted_border": "false",
          "layout_id": "banner-cta-layout",
          "logo_image": null,
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "section_id": 1780644056534,
          "sequence_number": 9,
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1777638819069_gamification_bag.png",
          "subheading": "Turn audience engagement into a game. Reward your most loyal members with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "theme_color": "#ffffff",
          "title": "Gamification, Leaderboards & Badges",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644056534"
        },
        {
          "background_color": "#000000",
          "background_text_color": "#000000",
          "button_text_color": "#ffffff",
          "created_at": 1780644058900,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_link_2": "",
          "cta_text": "See Example",
          "cta_text_2": "",
          "heading_font_size": "medium",
          "heading_position": "left",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779881050210_mo_b.jpg",
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779881050210_mo_b_m.jpg",
          "layout_id": "hero-layout",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "section_id": 1780644058900,
          "sequence_number": 10,
          "subheading": "Run your own advertising network to earn money from brand partners and provide special VIP offers to your members.",
          "theme_color": "#000000",
          "title": "Brand Sponsorship Advertising & Vip Discount Offers",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644058900"
        },
        {
          "background_color": "#000000",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1781000757822_wp12844884.jpg",
          "background_text_color": "#ffffff",
          "button_text_color": "#000000",
          "created_at": 1780644061305,
          "cta_link": "https://www.balancewithsienna.com/",
          "cta_text": "See Example",
          "heading_font_size": "medium",
          "heading_position": "left",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1777639383912_prof_gam_back.png",
          "include_highlighted_border": "false",
          "layout_id": "banner-cta-layout",
          "logo_image": null,
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "section_id": 1780644061305,
          "sequence_number": 11,
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1779801312399_mo_d.png",
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "theme_color": "#ffffff",
          "title": "Monetize Your Expertise Ecourses & Downloadables",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644061305"
        },
        {
          "background_color": "#ffffff",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1781002333263_background_flare__1_.jpg",
          "background_text_color": "#000000",
          "button_text_color": "#000000",
          "created_at": 1780644063687,
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool1.png",
          "creator_poster_1_title": "Go [Global]",
          "creator_poster_2_cta_1": "See Example",
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_cta_2": "",
          "creator_poster_2_cta_2_url": "",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1779881081273_mo_li.jpg",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_3_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "creator_poster_3_description": "Members can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
          "creator_poster_3_heading_position": "right",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1779798118613_mo_n.jpg",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779368583572_gs_tool1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779881081273_mo_li.jpg",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779798118613_mo_n.jpg",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Members can signup for your email newsletter on your own site and receive you latest news, ticketing and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "heading_font_size": "medium",
          "include_highlighted_border": "false",
          "layout_id": "creator-poster-layout",
          "name": "MORE POWERFUL TOOL",
          "page_id": 1780644034915,
          "pk": "PAGE#1780644034915",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#000000",
          "section_heading": "The Most Powerful {Direct-to-Member Platform} for Membership Organizations",
          "section_id": 1780644063687,
          "sequence_number": 12,
          "subheading": "TopFan eliminates the need for tens of expensive audience engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "theme_color": "#ffffff",
          "title": "More Powerful Tool",
          "updated_at": 1781596932216,
          "sk": "SECTION#1780644063687"
        }
      ]
    }
  },
  "politics-movements": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "updated_at": 1780643900478,
      "page_id": 1780643900478,
      "sk": "PAGE#1780643900478",
      "background_text_color": "#ffffff",
      "pk": "MARKETINGPAGE",
      "button_text_color": "#ffffff",
      "status": "PUBLISHED",
      "seoKeywords": "politicians, political leaders, public leaders, political campaigns, political creators, political influencers, candidate platform, supporter engagement, voter engagement, political content, connect with supporters, political community, political fundraising, campaign platform, public representatives, civic leaders, public representatives",
      "type": "MARKETING_LISTING",
      "meta_description": "The #1 Platform for Politicians and Political Leaders. Publish content, engage voters, raise funds, build memberships, sell merchandise, offer livestreams to strengthen supporter relationships while maintaining full control of your data.",
      "background_color": "#000000",
      "gsi1pk": "politics-movements",
      "title": "Politics & Movements",
      "created_at": 1780643900478,
      "text_color": "#000000",
      "meta_title": "Direct-to-Supporter Engagement Platform for Politicians",
      "secondary_background_color": "#000000",
      "post_text_color": "#ffffff",
      "gsi1sk": "PAGE#1780643900478",
      "url": "politics-movements",
      "sections": [
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779436316593_mobile_hero_image_professionals__1_.png",
          "subheading": "From Leadership to Lasting Impact",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "POLITICIAN HERO SECTION",
          "page_id": 1780643900478,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Turn Your Vision Into a Movement}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "Get Started",
          "created_at": 1780643904145,
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643904145,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643904145,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779436316593_featured_image_fitness__1_.png",
          "pk": "PAGE#1780643900478",
          "title": "Politician Hero Section",
          "sk": "SECTION#1780643904145"
        },
        {
          "subheading": "Leaders growing engaged communities around their vision and values.",
          "button_text_color": "#ffffff",
          "created_at": 1780643907546,
          "background_color": "#000000",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "name": "FEATURE CREATOR",
          "updated_at": 1780643907546,
          "page_id": 1780643900478,
          "post_text_color": "#ffffff",
          "layout_id": "feature-creator-layout",
          "section_id": 1780643907546,
          "section_heading": "[Featured Creators]",
          "secondary_background_color": "#232323",
          "pk": "PAGE#1780643900478",
          "is_visible": false,
          "title": "Feature Creator",
          "sk": "SECTION#1780643907546"
        },
        {
          "subheading": "Launch a free website and dedicated iOS and Android apps under your own domain. Personalize your presence, share updates, engage supporters, build communities, launch fundraising campaigns, and own the data.",
          "button_text_color": "#ffffff",
          "background_color": "#ffecfe",
          "name": "BUILD YOUR OWN FAN ENGAGEMENT PLATFORM",
          "page_id": 1780643900478,
          "highlighted_info_3_heading": "{1,000,000,000+}",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Build Your {Own Fan Engagement Platform}",
          "highlighted_info_1_description": "Revenue earned by creators using TopFan white-label technology.",
          "secondary_background_color": "#ababff",
          "cta_text": "See Example",
          "created_at": 1780643910454,
          "highlighted_info_position": "left",
          "heading_font_size": "medium",
          "highlighted_info_1_heading": "{$100,000,000+}",
          "background_text_color": "#000000",
          "highlighted_info_2_description": "Fan engagements facilitated for creators.",
          "seo_content": "",
          "theme_color": "#000000",
          "highlighted_info_2_heading": "{1,000,000,000+}",
          "highlighted_info_3_description": "Fan engagements facilitated by TopFan for creators",
          "updated_at": 1780643910454,
          "post_text_color": "#ffffff",
          "layout_id": "image-bottom-layout",
          "section_id": 1780643910454,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779437056252_wls_laptop_mockup_4.png",
          "pk": "PAGE#1780643900478",
          "title": "Build Your Own Fan Engagement Platform",
          "sk": "SECTION#1780643910454"
        },
        {
          "vcss_3_cta_1": "See Example",
          "button_text_color": "#000000",
          "vcss_1_cta_2_url": "",
          "vcss_3_cta_2": "",
          "background_color": "#000000",
          "vcss_3_description": "Sell tickets to in person meet-and-greets and special events from your own powerful platform.",
          "vcss_3_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_3_image": "https://cdn-www.topfans.com/TopFans/Home1779438186716_frame_2147225941.png",
          "vcss_2_description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
          "vcss_1_description": "Create membership plans and give your supporters access to your most valued content - including behind the scenes access,  videos, photo galleries, insightful articles, and personalized experiences.",
          "name": "FAN CLUB",
          "page_id": 1780643900478,
          "vcss_2_title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts",
          "vcss_1_image": "https://cdn-www.topfans.com/TopFans/Home1779879368893_p_f1.png",
          "secondary_background_color": "#000000",
          "vcss_2_cta_1": "See Example",
          "vcss_1_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_2_cta_2": "",
          "vcss_3_heading_position": "left",
          "created_at": 1780643924285,
          "background_text_color": "#ffffff",
          "vertical_card_snap_scroll_hero_image": "https://cdn-www.topfans.com/TopFans/Home1779437899911_image_1660__1_.png",
          "vcss_3_title": "In-Person [Event Ticketing]",
          "theme_color": "#ffffff",
          "vcss_2_image": "https://cdn-www.topfans.com/TopFans/Home1779792692205_pl-p2.png",
          "vcss_2_cta_2_url": "",
          "updated_at": 1780643924285,
          "post_text_color": "#ffffff",
          "layout_id": "vertical-card-snap-scroll-layout",
          "vertical_card_snap_scroll_slides": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779879368893_p_f1.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Create membership plans and give your supporters access to your most valued content - including behind the scenes access,  videos, photo galleries, insightful articles, and personalized experiences.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Subscriptions for Exclusive Content]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779792692205_pl-p2.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Offer paid access to your video series and audio content. Build your audience and earn directly from every listener and viewer.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Direct Sales & Distribution] of Episodic Videos & Podcasts"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779438186716_frame_2147225941.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "Sell tickets to in person meet-and-greets and special events from your own powerful platform.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "In-Person [Event Ticketing]"
            }
          ],
          "section_id": 1780643924285,
          "vcss_2_heading_position": "left",
          "vcss_3_cta_2_url": "",
          "vcss_2_cta_1_url": "https://www.balancewithsienna.com/",
          "vcss_1_heading_position": "left",
          "vcss_1_title": "[Subscriptions for Exclusive Content]",
          "vcss_1_cta_1": "See Example",
          "vcss_1_cta_2": "",
          "pk": "PAGE#1780643900478",
          "title": "Fan Club",
          "sk": "SECTION#1780643924285"
        },
        {
          "subheading": "",
          "button_text_color": "#000000",
          "background_color": "#fffbf2",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779440614399_link_in_bio_music_vertical__1_.png",
          "name": "CHAT ROOM",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_title": "[Community Chat Rooms]",
          "page_id": 1780643900478,
          "section_heading": "",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "created_at": 1780643927150,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643927150,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779440614399_link_in_bio_music_vertical__1_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Community Chat Rooms]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643927150,
          "creator_poster_1_description": "Create a safe space for your best fans to interact with each other, accept micro-tipping, direct messaging and more.",
          "pk": "PAGE#1780643900478",
          "title": "Chat Room",
          "sk": "SECTION#1780643927150"
        },
        {
          "hero_image_mobile": "https://cdn-www7.topfans.dev/gif/1779792917_p_m_live.gif",
          "subheading": "Go live with your audience anywhere and anytime.  Accept tips and sell your merchandise during the stream.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "name": "LIVE STREAM",
          "page_id": 1780643900478,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "Monetize Your \\n[Livestreams]",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643929641,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "cta_link_2": "",
          "theme_color": "#ffffff",
          "updated_at": 1780643929641,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643929641,
          "cta_text_2": "",
          "hero_image": "https://cdn-www7.topfans.dev/gif/1779792917_p_live.gif",
          "pk": "PAGE#1780643900478",
          "is_visible": true,
          "title": "Live Stream",
          "sk": "SECTION#1780643929641"
        },
        {
          "subheading": "",
          "pinned_horizontal_3_title": "{Personalized Experiences} with Calendar Scheduling",
          "button_text_color": "#ffffff",
          "background_color": "#ffebeb",
          "pinned_horizontal_1_cta_label": "See Example",
          "name": "MONETIZATIONS",
          "pinned_horizontal_3_cta_label": "See Example",
          "pinned_horizontal_2_image": "https://cdn-www.topfans.com/TopFans/Home1779439340904_frame_2147226328.png",
          "page_id": 1780643900478,
          "pinned_horizontal_3_subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar.",
          "section_heading": "",
          "secondary_background_color": "#ffffff",
          "pinned_horizontal_3_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pinned_horizontal_1_title": "{Sell Products} Directly",
          "pinned_horizontal_1_subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify.",
          "created_at": 1780643932700,
          "pinned_horizontal_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779439340903_links_list__2_.png",
              "cta_label": "See Example",
              "title": "{Sell Products} Directly",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Keep your fans inside your own app and website with native commerce that integrates with Shopify."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779439340904_frame_2147226328.png",
              "cta_label": "See Example",
              "title": "{Fan Relationship Management®}",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications."
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779439340904_1_1_schedule.png",
              "cta_label": "See Example",
              "title": "{Personalized Experiences} with Calendar Scheduling",
              "cta_redirection_url": "https://www.balancewithsienna.com/",
              "subtitle": "Offer one-on-one private video coaching calls, video shoutouts, in-person meet-ups with integrated scheduling via your Google or Outlook calendar."
            }
          ],
          "heading_font_size": "medium",
          "pinned_horizontal_2_cta_label": "See Example",
          "pinned_horizontal_2_title": "{Fan Relationship Management®}",
          "pinned_horizontal_3_image": "https://cdn-www.topfans.com/TopFans/Home1779439340904_1_1_schedule.png",
          "pinned_horizontal_1_image": "https://cdn-www.topfans.com/TopFans/Home1779439340903_links_list__2_.png",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "pinned_horizontal_1_cta_redirection_url": "https://www.balancewithsienna.com/",
          "updated_at": 1780643932700,
          "post_text_color": "#ffffff",
          "layout_id": "pinned-horizontal-scroll-layout",
          "section_id": 1780643932700,
          "pinned_horizontal_2_cta_redirection_url": "https://www.balancewithsienna.com/",
          "pk": "PAGE#1780643900478",
          "pinned_horizontal_2_subtitle": "Capture and own the detailed demographic, purchasing and content engagement history of your audience.  Build segments and directly send targeted emails, SMS, DMs, and Push Notifications.",
          "title": "Monetizations",
          "sk": "SECTION#1780643932700"
        },
        {
          "subheading": "Mobilize your supporters and turn your next campaign, political initiative, or community project into reality.",
          "button_text_color": "#ffffff",
          "created_at": 1780643935659,
          "background_color": "#000000",
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "theme_color": "#000000",
          "name": "CROWD FUNDING OF NEW PROJECT",
          "background_image": "https://cdn-www.topfans.com/TopFans/Home1779439952732_content_section__6_.png",
          "updated_at": 1780643935659,
          "page_id": 1780643900478,
          "post_text_color": "#ffffff",
          "layout_id": "image-upper-layout",
          "section_id": 1780643935659,
          "content_image": "https://cdn-www.topfans.com/TopFans/Home1779963973764_po_cff.png",
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Crowd Funding} of New Projects",
          "secondary_background_color": "#000000",
          "pk": "PAGE#1780643900478",
          "cta_text": "See Example",
          "title": "Crowd Funding of New Project",
          "sk": "SECTION#1780643935659"
        },
        {
          "subheading": "Turn audience engagement into a game. Reward your biggest supporters with points, badges, and leaderboard rankings that unlock exclusive perks and content.",
          "button_text_color": "#000000",
          "background_color": "#eaf0e2",
          "include_highlighted_border": "false",
          "name": "GAMIFICATION, LEADERBOARDS & BADGES",
          "page_id": 1780643900478,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Gamification, Leaderboards & Badges]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1779440180344_home1777638819069_gamification_bag.webp",
          "created_at": 1780643939478,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643939478,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643939478,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779440180344_home1777638819068_prof_gam_back.webp",
          "pk": "PAGE#1780643900478",
          "title": "Gamification, Leaderboards & Badges",
          "sk": "SECTION#1780643939478"
        },
        {
          "hero_image_mobile": "https://cdn-www.topfans.com/TopFans/Home1779879635625_p_b_m.png",
          "subheading": "Run your own advertising network to earn money from brands and provide special VIP offers to your fans.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "name": "BRAND SPONSORSHIP ADVERTISING & VIP DISCOUNT OFFERS",
          "page_id": 1780643900478,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "{Brand Sponsorship \\nAdvertising & VIP \\nDiscount Offers}",
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "created_at": 1780643946152,
          "heading_font_size": "medium",
          "background_text_color": "#000000",
          "cta_link_2": "",
          "theme_color": "#000000",
          "updated_at": 1780643946152,
          "post_text_color": "#ffffff",
          "layout_id": "hero-layout",
          "section_id": 1780643946152,
          "cta_text_2": "",
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779879635624_p_b_d.png",
          "pk": "PAGE#1780643900478",
          "title": "Brand Sponsorship Advertising & VIP Discount Offers",
          "sk": "SECTION#1780643946152"
        },
        {
          "subheading": "Package your training, insights, and exclusive coaching content into premium e-course programs and downloadable digital content.",
          "button_text_color": "#000000",
          "background_color": "#000000",
          "include_highlighted_border": "false",
          "name": "MONETIZE YOUR EXPERTISE ECOURSES & DOWNLOADABLES",
          "page_id": 1780643900478,
          "cta_link": "https://www.balancewithsienna.com/",
          "section_heading": "[Monetize Your Expertise with eCourses & Downloadables]",
          "logo_image": null,
          "secondary_background_color": "#000000",
          "heading_position": "left",
          "cta_text": "See Example",
          "side_image": "https://cdn-www.topfans.com/TopFans/Home1779964038421_po_cd.png",
          "created_at": 1780643949974,
          "heading_font_size": "medium",
          "background_text_color": "#ffffff",
          "theme_color": "#ffffff",
          "updated_at": 1780643949974,
          "post_text_color": "#ffffff",
          "layout_id": "banner-cta-layout",
          "section_id": 1780643949974,
          "hero_image": "https://cdn-www.topfans.com/TopFans/Home1779440826032_home1777638819068_prof_gam_back.webp",
          "pk": "PAGE#1780643900478",
          "title": "Monetize Your Expertise eCourses & Downloadables",
          "sk": "SECTION#1780643949974"
        },
        {
          "subheading": "TopFan eliminates the need for tens of expensive fan engagement and data management tools, bringing everything together in one place for a seamless fan experience.",
          "button_text_color": "#050505",
          "background_color": "#ffffff",
          "creator_poster_1_cta_2": "",
          "creator_poster_3_cta_1": "See Example",
          "creator_poster_3_cta_2": "",
          "creator_poster_1_cta_1": "See Example",
          "creator_poster_1_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_2_cta_2_url": "",
          "include_highlighted_border": "false",
          "creator_poster_1_image": "https://cdn-www.topfans.com/TopFans/Home1779441741912_link_in_bio_health_vertical__4_.png",
          "name": "MORE POWERFUL TOOLS",
          "creator_poster_1_heading_position": "right",
          "creator_poster_2_title": "[Link in Bio] Generator",
          "creator_poster_3_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_3_heading_position": "right",
          "creator_poster_1_title": "Go [Global]",
          "page_id": 1780643900478,
          "section_heading": "The Most Powerful {Direct-to-Supporter Platform} for Political Leaders & Movements",
          "secondary_background_color": "#000000",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_3_image": "https://cdn-www.topfans.com/TopFans/Home1779795116213_p-n.png",
          "creator_poster_2_heading_position": "left",
          "creator_poster_2_cta_1": "See Example",
          "created_at": 1780643953396,
          "heading_font_size": "medium",
          "creator_poster_3_title": "[Send Beautiful Branded Newsletters]",
          "background_text_color": "#000000",
          "theme_color": "#ffffff",
          "creator_poster_2_cta_2": "",
          "creator_poster_3_cta_2_url": "",
          "updated_at": 1780643953396,
          "post_text_color": "#ffffff",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779441741912_link_in_bio_health_vertical__4_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "Go [Global]"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779441741912_link_in_bio_health_vertical__2_.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "left",
              "cta_2_url": "",
              "description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Link in Bio] Generator"
            },
            {
              "image": "https://cdn-www.topfans.com/TopFans/Home1779795116213_p-n.png",
              "cta_1_url": "https://www.balancewithsienna.com/",
              "heading_position": "right",
              "cta_2_url": "",
              "description": "Supporters can signup for your email newsletter on your own site and receive you latest news, ticketing, fundraising and merchandise information.",
              "cta_2": "",
              "cta_1": "See Example",
              "title": "[Send Beautiful Branded Newsletters]"
            }
          ],
          "layout_id": "creator-poster-layout",
          "section_id": 1780643953396,
          "creator_poster_2_cta_1_url": "https://www.balancewithsienna.com/",
          "creator_poster_1_description": "Your platform automatically translates into 243 world languages and accepts 50+ currencies with localized pricing optimizations.",
          "creator_poster_2_description": "No more fragmented 3rd party links.  Sell directly on TikTok and Instagram, with a dynamic Link in Bio that has all your courses, livestreams, event tickets, merch, and content directly embedded.",
          "creator_poster_3_description": "Supporters can signup for your email newsletter on your own site and receive you latest news, ticketing, fundraising and merchandise information.",
          "creator_poster_2_image": "https://cdn-www.topfans.com/TopFans/Home1779441741912_link_in_bio_health_vertical__2_.png",
          "pk": "PAGE#1780643900478",
          "title": "More Powerful Tools",
          "sk": "SECTION#1780643953396"
        }
      ]
    }
  }
};
